(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"ani_test_atlas_P_", frames: [[1196,0,680,680],[0,809,400,350],[804,809,350,350],[1608,1351,350,350],[0,1161,400,350],[1206,1351,400,350],[0,1513,400,350],[402,1513,400,350],[402,1161,400,350],[804,1351,400,350],[402,809,400,350],[0,0,596,807],[598,0,596,807],[1196,682,531,667]]},
		{name:"ani_test_atlas_P_2", frames: [[1408,1056,350,350],[1408,1408,350,350],[0,704,350,350],[1408,0,350,350],[1056,1056,350,350],[704,0,350,350],[704,1408,350,350],[704,1056,350,350],[0,1056,350,350],[0,1408,350,350],[0,0,350,350],[352,0,350,350],[1408,352,350,350],[0,352,350,350],[1056,0,350,350],[352,352,350,350],[352,704,350,350],[352,1056,350,350],[1056,352,350,350],[352,1408,350,350],[1056,704,350,350],[1408,704,350,350],[704,704,350,350],[1056,1408,350,350],[704,352,350,350]]},
		{name:"ani_test_atlas_P_3", frames: [[0,0,350,350],[0,1408,350,350],[0,704,350,350],[0,1056,350,350],[0,352,350,350],[352,352,350,350],[352,0,350,350],[1056,1056,350,350],[1056,0,350,350],[1056,1408,350,350],[352,1056,350,350],[1056,352,350,350],[704,704,350,350],[704,1056,350,350],[1408,1408,350,350],[704,0,350,350],[352,1408,350,350],[704,352,350,350],[704,1408,350,350],[1408,1056,350,350],[1408,352,350,350],[1408,704,350,350],[1056,704,350,350],[352,704,350,350],[1408,0,350,350]]},
		{name:"ani_test_atlas_P_4", frames: [[352,1056,350,350],[704,352,350,350],[704,0,350,350],[352,1408,350,350],[0,352,350,350],[0,704,350,350],[0,1056,350,350],[0,1408,350,350],[0,0,350,350],[1056,352,350,350],[352,0,350,350],[1056,0,350,350],[1408,0,350,350],[352,352,350,350],[352,704,350,350],[1408,352,350,350],[704,704,350,350],[704,1056,350,350],[704,1408,350,350],[1056,1408,350,350],[1056,1056,350,350],[1408,704,350,350],[1408,1056,350,350],[1056,704,350,350],[1408,1408,350,350]]},
		{name:"ani_test_atlas_P_5", frames: [[352,0,350,350],[704,0,350,350],[352,352,350,350],[0,352,350,350],[1056,0,350,350],[352,704,350,350],[0,0,350,350],[0,704,350,350],[0,1056,350,350],[0,1408,350,350],[1408,0,350,350],[704,352,350,350],[352,1408,350,350],[704,704,350,350],[704,1056,350,350],[704,1408,350,350],[352,1056,350,350],[1056,352,350,350],[1408,352,350,350],[1056,704,350,350],[1408,1408,350,350],[1056,1056,350,350],[1408,704,350,350],[1408,1056,350,350],[1056,1408,350,350]]},
		{name:"ani_test_atlas_P_6", frames: [[352,704,350,350],[1056,0,350,350],[352,1056,350,350],[704,0,350,350],[0,1408,350,350],[352,0,350,350],[352,352,350,350],[1056,352,350,350],[1408,0,350,350],[0,704,350,350],[0,352,350,350],[352,1408,350,350],[0,1056,350,350],[1408,352,350,350],[704,352,350,350],[704,704,350,350],[704,1056,350,350],[0,0,350,350],[1408,704,350,350],[1408,1056,350,350],[1408,1408,350,350],[704,1408,350,350],[1056,704,350,350],[1056,1056,350,350],[1056,1408,350,350]]},
		{name:"ani_test_atlas_P_7", frames: [[1056,704,350,350],[704,1408,350,350],[0,0,350,350],[1056,352,350,350],[0,1056,350,350],[704,1056,350,350],[1408,704,350,350],[1056,1056,350,350],[352,0,350,350],[704,0,350,350],[0,1408,350,350],[1056,1408,350,350],[1056,0,350,350],[1408,1056,350,350],[1408,1408,350,350],[0,352,350,350],[1408,0,350,350],[0,704,350,350],[352,352,350,350],[352,704,350,350],[1408,352,350,350],[352,1056,350,350],[352,1408,350,350],[704,352,350,350],[704,704,350,350]]},
		{name:"ani_test_atlas_P_8", frames: [[0,1408,350,350],[352,0,350,350],[0,704,350,350],[704,0,350,350],[0,0,350,350],[0,352,350,350],[0,1056,350,350],[1056,0,350,350],[1408,0,350,350],[352,1408,350,350],[1056,1408,350,350],[1056,704,350,350],[1408,1056,350,350],[704,1408,350,350],[704,352,350,350],[1056,352,350,350],[704,1056,350,350],[352,704,350,350],[352,352,350,350],[352,1056,350,350],[1056,1056,350,350],[1408,352,350,350],[1408,704,350,350],[704,704,350,350],[1408,1408,350,350]]},
		{name:"ani_test_atlas_P_9", frames: [[1477,1197,220,220],[1056,1544,220,220],[1278,1419,220,220],[1056,1322,220,220],[1500,1419,220,220],[1278,1641,220,220],[1056,0,350,350],[0,704,350,350],[0,1056,350,350],[352,352,350,350],[352,704,350,350],[352,0,350,350],[704,0,350,350],[704,352,350,350],[704,704,350,350],[352,1056,350,350],[352,1408,350,350],[704,1056,350,350],[0,0,350,350],[704,1408,350,350],[0,1408,350,350],[1056,352,350,350],[1056,704,350,350],[0,352,350,350],[1500,1641,220,220],[888,1766,220,220],[1408,0,220,220],[1408,222,220,220],[1495,666,220,220],[1408,444,220,220],[0,1760,220,220],[1495,888,220,220],[1699,1110,220,220],[1630,0,220,220],[1630,222,220,220],[1630,444,220,220],[1717,666,220,220],[222,1760,220,220],[1717,888,220,220],[444,1760,220,220],[1722,1332,220,220],[666,1760,220,220],[1722,1776,220,220],[1722,1554,220,220],[1056,1056,437,139],[1056,1197,419,123]]},
		{name:"ani_test_atlas_P_10", frames: [[702,422,218,42],[1772,442,202,42],[1421,575,152,42],[1049,246,293,42],[663,466,202,42],[1581,574,152,42],[154,598,152,42],[983,618,152,42],[1072,141,132,42],[408,521,192,42],[304,245,301,42],[1575,618,152,42],[0,597,152,42],[521,598,152,42],[1072,97,132,42],[1776,354,224,42],[973,378,232,42],[1572,310,251,42],[1060,334,242,42],[0,465,202,42],[867,466,202,42],[0,245,302,42],[0,333,251,42],[308,609,152,42],[204,466,202,42],[1845,212,152,42],[1267,575,152,42],[1788,706,132,42],[1314,310,256,42],[816,334,242,42],[234,378,232,42],[468,389,232,42],[1067,707,132,42],[675,599,152,42],[555,301,259,42],[1049,202,354,42],[1049,290,263,42],[1845,168,152,42],[1344,266,292,42],[1568,442,202,43],[253,333,241,43],[1868,530,132,42],[1386,706,132,42],[1735,574,152,42],[1638,266,291,42],[922,422,217,42],[775,555,162,42],[1520,706,132,42],[1654,706,132,42],[0,421,221,42],[739,378,232,42],[1207,398,231,42],[829,618,152,42],[1141,442,212,42],[496,345,241,42],[0,377,232,42],[308,697,151,42],[1213,0,200,200],[1415,0,200,200],[1617,0,200,200],[1888,398,112,24],[462,686,152,42],[0,0,220,220],[616,687,152,42],[1203,530,192,42],[612,510,201,42],[268,741,132,42],[1811,750,156,24],[1304,354,234,42],[1335,750,132,42],[0,729,132,42],[863,750,132,42],[1931,256,69,24],[439,800,71,23],[720,0,491,95],[759,97,311,100],[759,199,288,100],[1889,574,98,24],[1729,618,152,42],[0,641,152,42],[1144,776,97,23],[1889,600,98,24],[1355,442,211,42],[997,751,145,24],[462,642,152,42],[939,574,162,42],[924,662,152,42],[408,477,202,42],[1907,652,73,24],[154,686,152,42],[402,741,46,23],[184,554,171,42],[1397,531,182,42],[1599,662,152,42],[501,775,97,23],[1071,486,202,42],[1819,124,172,42],[815,510,192,43],[223,422,221,42],[0,289,281,42],[0,773,118,23],[1469,750,169,24],[1640,750,169,24],[1860,776,95,23],[1469,776,96,23],[1540,354,234,42],[770,662,152,42],[1753,662,152,42],[774,794,73,23],[1103,574,162,42],[600,775,97,23],[402,774,97,23],[1943,52,47,24],[616,643,152,42],[1907,678,72,24],[729,750,132,42],[462,609,46,24],[222,0,496,95],[283,289,270,42],[1232,663,152,42],[1201,707,132,42],[770,706,151,42],[612,477,46,24],[0,685,152,42],[1819,0,122,122],[1943,26,47,24],[75,800,71,23],[1386,663,46,23],[0,553,182,42],[154,642,152,42],[1316,794,73,23],[216,785,71,24],[1291,619,152,42],[1405,202,218,62],[1335,707,46,23],[816,301,171,24],[1567,776,96,23],[607,245,142,42],[357,565,162,42],[1772,486,202,42],[1883,626,95,24],[289,785,73,23],[1943,0,48,24],[364,799,73,23],[148,800,46,23],[308,653,152,42],[1992,28,5,5],[1993,14,5,5],[1993,0,7,5],[1993,21,5,5],[1992,35,5,5],[1943,111,12,5],[1976,104,13,5],[1943,104,16,5],[1961,104,13,5],[1993,7,5,5],[134,730,132,42],[1445,662,152,42],[1664,398,222,42],[1266,751,64,23],[1078,663,152,42],[1009,530,192,42],[0,509,202,42],[602,554,171,42],[849,794,73,23],[923,706,142,42],[1137,619,152,42],[120,774,94,24],[204,510,202,42],[924,794,71,23],[1243,776,71,24],[1440,398,222,42],[1825,310,172,42],[1683,530,183,42],[1391,794,73,23],[521,565,73,24],[1479,487,202,42],[1931,282,69,24],[997,777,95,23],[446,433,215,42],[1094,777,46,23],[1683,487,73,24],[461,730,132,42],[739,345,73,24],[1922,704,72,24],[1144,751,120,23],[1275,486,202,42],[1445,619,120,23],[1943,78,47,24],[0,798,73,23],[595,731,132,42],[1625,202,218,62],[699,794,73,23],[1665,776,96,23],[1763,776,95,23],[1581,531,98,24],[989,301,46,24],[222,171,535,72],[222,97,535,72]]}
];


// symbols:



(lib.Адскийогонь = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Адскийогонь_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.Близнецы = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.Божественнаястойка = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.Влепешку = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.Весы = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.Ветер = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.Вода = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.Водолей = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.Вопльсмерти = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.Вращающийсякоготь = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.Градискр = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.Гроза = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.Гром = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.Дева = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.Дезориентация = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.Дождьметеоров = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.Заряженныйудар = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.Заряженныйудар_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.Захватдуши = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.Землетрясение = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.Игровойнаборза20 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.Инстинктубийцы = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.Камень = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.Каранебесная = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.Козерог = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.Лев = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.Лед = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.Магическаястрела = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.Магическаяцепь = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.Мощныйпинок = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.Небесныйвихрь = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.Овен = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.Огонь = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.Пламеннаяярость = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.ПодарочнаякартаAmazon = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.Пробиваниеброни = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.Рак = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.РозыгрышAirPodsPro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.РозыгрышPS5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.РозыгрышSwitch = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.Рыбы = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.Рыбы_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.Скорпион = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.Стремительныйудар = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.Струяпламени = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.Суперсила = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.Телец = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.Трава = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.Ударнаотмашь = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.Ударсвоздуха = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib._20GameBundle = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.Хитрость = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.Хлыстдемона = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.Цепочкаударов = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.Четвернойудар = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.椭圆550 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Эхоудар = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib._0 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib._0png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._0png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._0png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._0png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._0png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._0png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._00 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._001 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._001png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._001png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._001png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._001png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._001png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._001png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._001png复制16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._001png复制17 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._001png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._001png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._001png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._001png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._001png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._001png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._001png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._001png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._002 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._002png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._002png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._002png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._002png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._002png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._002png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._002png复制16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._002png复制17 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._002png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._002png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._002png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._002png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._002png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._002png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_2"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._002png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._002png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._003 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._003png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._003png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._003png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._003png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._003png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._003png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._003png复制16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._003png复制17 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._003png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._003png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._003png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._003png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._003png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._003png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._003png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._003png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._004 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._004png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._004png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._004png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._004png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._004png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._004png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._004png复制16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._004png复制17 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._004png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._004png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._004png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._004png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._004png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._004png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_7"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._004png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._004png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._005 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._005png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._005png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._005png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._005png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._005png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._005png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._005png复制16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._005png复制17 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._005png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._005png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._005png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._005png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._005png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._005png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._005png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._005png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._006 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._006png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._006png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._006png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._006png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._006png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._006png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._006png复制16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._006png复制17 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._006png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._006png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._006png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._006png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._006png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_8"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._006png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._006png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._006png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._007 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._007png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._007png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._007png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._007png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._007png复制14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._007png复制15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._007png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._007png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._007png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._007png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._007png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._007png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._007png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._007png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._008 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._008png复制10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._008png复制11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._008png复制12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._008png复制13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._008png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._008png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._008png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._008png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._008png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._008png复制7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._008png复制8 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._008png复制9 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._009 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._009png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._009png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._009png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._009png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._009png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_3"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._01 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._01png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._010 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._010png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._010png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._010png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._010png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._010png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._011 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._011png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._011png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._011png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._011png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._011png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._012 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._012png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_4"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._012png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._012png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._012png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._012png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._013 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._013png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._013png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._013png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._013png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._014 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._014png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._014png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._014png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib._015 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib._015png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._016 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._016png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._017 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._017png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib._018 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib._019 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._02 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._02png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._020 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._03 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._03png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._04 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._04png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._05 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._05png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._06 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._06png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._07 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib._07png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib._08 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib._09 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib._1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib._1png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._1png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib._1png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib._1png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib._1png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib._1png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib._10 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib._11 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib._12 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib._13 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib._14 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib._15 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib._16 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_5"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib._2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(59);
}).prototype = p = new cjs.Sprite();



(lib._2png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib._2png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib._2png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib._2png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib._2png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib._2png复制6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib._20Y = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(60);
}).prototype = p = new cjs.Sprite();



(lib._23BG = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(61);
}).prototype = p = new cjs.Sprite();



(lib._3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib._3png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib._3png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib._3png复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib._3png复制4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib._3png复制5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib._4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(62);
}).prototype = p = new cjs.Sprite();



(lib._4png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib._4png复制2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib._4BG = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(63);
}).prototype = p = new cjs.Sprite();



(lib._5BG = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(64);
}).prototype = p = new cjs.Sprite();



(lib._7BG = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(65);
}).prototype = p = new cjs.Sprite();



(lib.AirSlash = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(66);
}).prototype = p = new cjs.Sprite();



(lib.AirPodsPro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(67);
}).prototype = p = new cjs.Sprite();



(lib.AmazonGiftCard = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(68);
}).prototype = p = new cjs.Sprite();



(lib.Anemo = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(69);
}).prototype = p = new cjs.Sprite();



(lib.Aquarius = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(70);
}).prototype = p = new cjs.Sprite();



(lib.Aries = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(71);
}).prototype = p = new cjs.Sprite();



(lib.Aries_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(72);
}).prototype = p = new cjs.Sprite();



(lib.BDQ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(73);
}).prototype = p = new cjs.Sprite();



(lib.BG001 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.bg2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.bg_groundpng复制3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(74);
}).prototype = p = new cjs.Sprite();



(lib.bg_p1_name = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(75);
}).prototype = p = new cjs.Sprite();



(lib.bg_p2_name = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(76);
}).prototype = p = new cjs.Sprite();



(lib.blws = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(77);
}).prototype = p = new cjs.Sprite();



(lib.BrutalBite = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(78);
}).prototype = p = new cjs.Sprite();



(lib.BrutalBite_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(79);
}).prototype = p = new cjs.Sprite();



(lib.BSDH = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(80);
}).prototype = p = new cjs.Sprite();



(lib.BSLB = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(81);
}).prototype = p = new cjs.Sprite();



(lib.BurstofFlame = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(82);
}).prototype = p = new cjs.Sprite();



(lib.BXCTLB = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(83);
}).prototype = p = new cjs.Sprite();



(lib.Cancer = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(84);
}).prototype = p = new cjs.Sprite();



(lib.Capricornus = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(85);
}).prototype = p = new cjs.Sprite();



(lib.ChainStrike = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(86);
}).prototype = p = new cjs.Sprite();



(lib.ChargedShock = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(87);
}).prototype = p = new cjs.Sprite();



(lib.CNZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(88);
}).prototype = p = new cjs.Sprite();



(lib.Cryo = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(89);
}).prototype = p = new cjs.Sprite();



(lib.CX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(90);
}).prototype = p = new cjs.Sprite();



(lib.DeathsCry = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(91);
}).prototype = p = new cjs.Sprite();



(lib.DemonWhip = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(92);
}).prototype = p = new cjs.Sprite();



(lib.Dendro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(93);
}).prototype = p = new cjs.Sprite();



(lib.DGJG = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(94);
}).prototype = p = new cjs.Sprite();



(lib.Disorientation = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(95);
}).prototype = p = new cjs.Sprite();



(lib.DivineStance = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(96);
}).prototype = p = new cjs.Sprite();



(lib.DrawforPS5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(97);
}).prototype = p = new cjs.Sprite();



(lib.DrawforSwitch = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(98);
}).prototype = p = new cjs.Sprite();



(lib.DrawbforAirPodsPro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(99);
}).prototype = p = new cjs.Sprite();



(lib.DRBDQ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(100);
}).prototype = p = new cjs.Sprite();



(lib.DXZDDGJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(101);
}).prototype = p = new cjs.Sprite();



(lib.DXZDTGJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(102);
}).prototype = p = new cjs.Sprite();



(lib.dyzh = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(103);
}).prototype = p = new cjs.Sprite();



(lib.dyzh02 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(104);
}).prototype = p = new cjs.Sprite();



(lib.EarthquakeSmash = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(105);
}).prototype = p = new cjs.Sprite();



(lib.EchoStrike = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(106);
}).prototype = p = new cjs.Sprite();



(lib.Electro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(107);
}).prototype = p = new cjs.Sprite();



(lib.FDC = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(108);
}).prototype = p = new cjs.Sprite();



(lib.FlamingFury = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(109);
}).prototype = p = new cjs.Sprite();



(lib.FLZT = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(110);
}).prototype = p = new cjs.Sprite();



(lib.FXCL = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(111);
}).prototype = p = new cjs.Sprite();



(lib.FY = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(112);
}).prototype = p = new cjs.Sprite();



(lib.Gemini = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(113);
}).prototype = p = new cjs.Sprite();



(lib.Gemini_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(114);
}).prototype = p = new cjs.Sprite();



(lib.Geo = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(115);
}).prototype = p = new cjs.Sprite();



(lib.GM = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(116);
}).prototype = p = new cjs.Sprite();



(lib.ground2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(117);
}).prototype = p = new cjs.Sprite();



(lib.HeavensJudgement = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(118);
}).prototype = p = new cjs.Sprite();



(lib.Hellfire = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(119);
}).prototype = p = new cjs.Sprite();



(lib.Hellfire2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(120);
}).prototype = p = new cjs.Sprite();



(lib.Hellfire3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(121);
}).prototype = p = new cjs.Sprite();



(lib.HX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(122);
}).prototype = p = new cjs.Sprite();



(lib.Hydro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(123);
}).prototype = p = new cjs.Sprite();



(lib.icon_pk = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(124);
}).prototype = p = new cjs.Sprite();



(lib.JX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(125);
}).prototype = p = new cjs.Sprite();



(lib.JXZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(126);
}).prototype = p = new cjs.Sprite();



(lib.JZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(127);
}).prototype = p = new cjs.Sprite();



(lib.KillerInstinct = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(128);
}).prototype = p = new cjs.Sprite();



(lib.Leo = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(129);
}).prototype = p = new cjs.Sprite();



(lib.Leo_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(130);
}).prototype = p = new cjs.Sprite();



(lib.LHJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(131);
}).prototype = p = new cjs.Sprite();



(lib.Libra = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(132);
}).prototype = p = new cjs.Sprite();



(lib.loser = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(133);
}).prototype = p = new cjs.Sprite();



(lib.LX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(134);
}).prototype = p = new cjs.Sprite();



(lib.LYMXGWK = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(135);
}).prototype = p = new cjs.Sprite();



(lib.LZGJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(136);
}).prototype = p = new cjs.Sprite();



(lib.MagicBolt = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(137);
}).prototype = p = new cjs.Sprite();



(lib.MagicChain = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(138);
}).prototype = p = new cjs.Sprite();



(lib.MeteorFire = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(139);
}).prototype = p = new cjs.Sprite();



(lib.MFGJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(140);
}).prototype = p = new cjs.Sprite();



(lib.MHB = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(141);
}).prototype = p = new cjs.Sprite();



(lib.MJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(142);
}).prototype = p = new cjs.Sprite();



(lib.MJZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(143);
}).prototype = p = new cjs.Sprite();



(lib.MX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(144);
}).prototype = p = new cjs.Sprite();



(lib.Outwit = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(145);
}).prototype = p = new cjs.Sprite();



(lib.P001 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(146);
}).prototype = p = new cjs.Sprite();



(lib.P001_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(147);
}).prototype = p = new cjs.Sprite();



(lib.P002 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(148);
}).prototype = p = new cjs.Sprite();



(lib.P003 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(149);
}).prototype = p = new cjs.Sprite();



(lib.P004 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(150);
}).prototype = p = new cjs.Sprite();



(lib.P005 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(151);
}).prototype = p = new cjs.Sprite();



(lib.P006 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(152);
}).prototype = p = new cjs.Sprite();



(lib.P007 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(153);
}).prototype = p = new cjs.Sprite();



(lib.P008 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(154);
}).prototype = p = new cjs.Sprite();



(lib.P009 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(155);
}).prototype = p = new cjs.Sprite();



(lib.Pisces = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(156);
}).prototype = p = new cjs.Sprite();



(lib.PowerKick = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(157);
}).prototype = p = new cjs.Sprite();



(lib.PowerPuncture = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(158);
}).prototype = p = new cjs.Sprite();



(lib.PS5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(159);
}).prototype = p = new cjs.Sprite();



(lib.Pyro = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(160);
}).prototype = p = new cjs.Sprite();



(lib.QuadrupleHit = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(161);
}).prototype = p = new cjs.Sprite();



(lib.QuickCrush = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(162);
}).prototype = p = new cjs.Sprite();



(lib.Roundhouse = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(163);
}).prototype = p = new cjs.Sprite();



(lib.RSD = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(164);
}).prototype = p = new cjs.Sprite();



(lib.Sagittarius = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(165);
}).prototype = p = new cjs.Sprite();



(lib.Scorpio = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(166);
}).prototype = p = new cjs.Sprite();



(lib.SDFB = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(167);
}).prototype = p = new cjs.Sprite();



(lib.SkywardSpiral = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(168);
}).prototype = p = new cjs.Sprite();



(lib.SLZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(169);
}).prototype = p = new cjs.Sprite();



(lib.SLZ_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(170);
}).prototype = p = new cjs.Sprite();



(lib.SoulPossession = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(171);
}).prototype = p = new cjs.Sprite();



(lib.SparkVolley = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(172);
}).prototype = p = new cjs.Sprite();



(lib.SpinningClaw = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(173);
}).prototype = p = new cjs.Sprite();



(lib.SPZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(174);
}).prototype = p = new cjs.Sprite();



(lib.SSZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(175);
}).prototype = p = new cjs.Sprite();



(lib.SuperStrength = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(176);
}).prototype = p = new cjs.Sprite();



(lib.superpowers = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(177);
}).prototype = p = new cjs.Sprite();



(lib.Switch = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(178);
}).prototype = p = new cjs.Sprite();



(lib.SwoopingStrike = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(179);
}).prototype = p = new cjs.Sprite();



(lib.SX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(180);
}).prototype = p = new cjs.Sprite();



(lib.SYZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(181);
}).prototype = p = new cjs.Sprite();



(lib.Taurus = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(182);
}).prototype = p = new cjs.Sprite();



(lib.Taurus_1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(183);
}).prototype = p = new cjs.Sprite();



(lib.TCZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(184);
}).prototype = p = new cjs.Sprite();



(lib.TDBWQ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(185);
}).prototype = p = new cjs.Sprite();



(lib.Thunderstorm = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(186);
}).prototype = p = new cjs.Sprite();



(lib.TMLXQ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(187);
}).prototype = p = new cjs.Sprite();



(lib.TX = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(188);
}).prototype = p = new cjs.Sprite();



(lib.TXZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(189);
}).prototype = p = new cjs.Sprite();



(lib.Virgo = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(190);
}).prototype = p = new cjs.Sprite();



(lib.winner = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(191);
}).prototype = p = new cjs.Sprite();



(lib.XFT = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(192);
}).prototype = p = new cjs.Sprite();



(lib.XLFZ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(193);
}).prototype = p = new cjs.Sprite();



(lib.xyfz = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(194);
}).prototype = p = new cjs.Sprite();



(lib.xyls = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(195);
}).prototype = p = new cjs.Sprite();



(lib.ZJ = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(196);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙1 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙2 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙3 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙4 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙5 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙6 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.冲浪龙7 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_6"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.组110 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.组28拷贝 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.组55拷贝 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(197);
}).prototype = p = new cjs.Sprite();



(lib.组55拷贝png复制 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_10"];
	this.gotoAndStop(198);
}).prototype = p = new cjs.Sprite();



(lib.组94 = function() {
	this.spriteSheet = ss["ani_test_atlas_P_9"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.龙四 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制13();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制13();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制13();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制13();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制13();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制13();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制11();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制9();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.龙五 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制14();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制14();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制14();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制14();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制14();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制14();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制12();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制10();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.龙二 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制11();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制11();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制11();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制11();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制11();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制11();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制9();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制7();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.龙三 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制12();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制12();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制12();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制12();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制12();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制12();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制10();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制8();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.龙一 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制15();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制15();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制15();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制15();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制15();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制15();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制13();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制11();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.补间8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.bg_groundpng复制3();
	this.instance.parent = this;
	this.instance.setTransform(-245.5,-47.5);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(51,0,255,0.098)").s().p("EgmWAHbIAAu1MBMtAAAIAAO1g");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-245.5,-47.5,491,95);


(lib.补间7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.bg_groundpng复制3();
	this.instance.parent = this;
	this.instance.setTransform(-245.5,-47.5);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(51,0,255,0)").s().p("EgmWAHbIAAu1MBMtAAAIAAO1g");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-245.5,-47.5,491,95);


(lib.肥宅龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制6();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制6();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制6();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制6();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制6();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制6();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制6();
	this.instance_6.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.篮球龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制9();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制9();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制9();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制9();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制9();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制9();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制8();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制6();
	this.instance_7.parent = this;

	this.instance_8 = new lib._009png复制5();
	this.instance_8.parent = this;

	this.instance_9 = new lib._010png复制5();
	this.instance_9.parent = this;

	this.instance_10 = new lib._011png复制5();
	this.instance_10.parent = this;

	this.instance_11 = new lib._012png复制5();
	this.instance_11.parent = this;

	this.instance_12 = new lib._013png复制4();
	this.instance_12.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},3).to({state:[{t:this.instance_11}]},3).to({state:[{t:this.instance_12}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.疫苗龙1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制2();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制2();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制2();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制2();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制2();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制2();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制2();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制2();
	this.instance_7.parent = this;

	this.instance_8 = new lib._009png复制2();
	this.instance_8.parent = this;

	this.instance_9 = new lib._010png复制2();
	this.instance_9.parent = this;

	this.instance_10 = new lib._011png复制2();
	this.instance_10.parent = this;

	this.instance_11 = new lib._012png复制2();
	this.instance_11.parent = this;

	this.instance_12 = new lib._013png复制2();
	this.instance_12.parent = this;

	this.instance_13 = new lib._014png复制2();
	this.instance_13.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_12}]},2).to({state:[{t:this.instance_13}]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.玩游戏龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制17();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制17();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制17();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制17();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制17();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制17();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制15();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制13();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.沙滩度假龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制16();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制16();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制16();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制16();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制16();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制16();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制14();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制12();
	this.instance_7.parent = this;

	this.instance_8 = new lib._009png复制6();
	this.instance_8.parent = this;

	this.instance_9 = new lib._010png复制6();
	this.instance_9.parent = this;

	this.instance_10 = new lib._011png复制6();
	this.instance_10.parent = this;

	this.instance_11 = new lib._012png复制6();
	this.instance_11.parent = this;

	this.instance_12 = new lib._013png复制5();
	this.instance_12.parent = this;

	this.instance_13 = new lib._014png复制4();
	this.instance_13.parent = this;

	this.instance_14 = new lib._015png复制();
	this.instance_14.parent = this;

	this.instance_15 = new lib._016png复制();
	this.instance_15.parent = this;

	this.instance_16 = new lib._017png复制();
	this.instance_16.parent = this;

	this.instance_17 = new lib._018();
	this.instance_17.parent = this;

	this.instance_18 = new lib._019();
	this.instance_18.parent = this;

	this.instance_19 = new lib._020();
	this.instance_19.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},3).to({state:[{t:this.instance_11}]},3).to({state:[{t:this.instance_12}]},3).to({state:[{t:this.instance_13}]},3).to({state:[{t:this.instance_14}]},3).to({state:[{t:this.instance_15}]},3).to({state:[{t:this.instance_16}]},3).to({state:[{t:this.instance_17}]},3).to({state:[{t:this.instance_18}]},3).to({state:[{t:this.instance_19}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.喝可乐龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制8();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制8();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制8();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制8();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制8();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制8();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制7();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制5();
	this.instance_7.parent = this;

	this.instance_8 = new lib._009png复制4();
	this.instance_8.parent = this;

	this.instance_9 = new lib._010png复制4();
	this.instance_9.parent = this;

	this.instance_10 = new lib._011png复制4();
	this.instance_10.parent = this;

	this.instance_11 = new lib._012png复制4();
	this.instance_11.parent = this;

	this.instance_12 = new lib._013png复制3();
	this.instance_12.parent = this;

	this.instance_13 = new lib._014png复制3();
	this.instance_13.parent = this;

	this.instance_14 = new lib._015();
	this.instance_14.parent = this;

	this.instance_15 = new lib._016();
	this.instance_15.parent = this;

	this.instance_16 = new lib._017();
	this.instance_16.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},3).to({state:[{t:this.instance_11}]},3).to({state:[{t:this.instance_12}]},3).to({state:[{t:this.instance_13}]},3).to({state:[{t:this.instance_14}]},3).to({state:[{t:this.instance_15}]},3).to({state:[{t:this.instance_16}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.winnerIcon = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.组94();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.winnerIcon, new cjs.Rectangle(0,0,419,123), null);


(lib.winnerDragonWrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.winnerDragonWrap, null, null);


(lib.海盗龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制7();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制7();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制7();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制7();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制7();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制7();
	this.instance_5.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.textWinner = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.winner();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.textWinner, new cjs.Rectangle(0,0,218,62), null);


(lib.textLoser = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.loser();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.textLoser, new cjs.Rectangle(0,0,218,62), null);


(lib.test456 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._01();
	this.instance.parent = this;
	this.instance.setTransform(0,2);

	this.instance_1 = new lib._02();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,2);

	this.instance_2 = new lib._03();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0,2);

	this.instance_3 = new lib._04();
	this.instance_3.parent = this;
	this.instance_3.setTransform(0,2);

	this.instance_4 = new lib._05();
	this.instance_4.parent = this;
	this.instance_4.setTransform(0,2);

	this.instance_5 = new lib._06();
	this.instance_5.parent = this;
	this.instance_5.setTransform(0,2);

	this.instance_6 = new lib._07();
	this.instance_6.parent = this;
	this.instance_6.setTransform(0,2);

	this.instance_7 = new lib._08();
	this.instance_7.parent = this;
	this.instance_7.setTransform(0,2);

	this.instance_8 = new lib._09();
	this.instance_8.parent = this;
	this.instance_8.setTransform(0,2);

	this.instance_9 = new lib._10();
	this.instance_9.parent = this;
	this.instance_9.setTransform(0,2);

	this.instance_10 = new lib._11();
	this.instance_10.parent = this;
	this.instance_10.setTransform(0,2);

	this.instance_11 = new lib._12();
	this.instance_11.parent = this;
	this.instance_11.setTransform(0,2);

	this.instance_12 = new lib._13();
	this.instance_12.parent = this;
	this.instance_12.setTransform(0,2);

	this.instance_13 = new lib._14();
	this.instance_13.parent = this;
	this.instance_13.setTransform(0,2);

	this.instance_14 = new lib._15();
	this.instance_14.parent = this;
	this.instance_14.setTransform(0,2);

	this.instance_15 = new lib._16();
	this.instance_15.parent = this;
	this.instance_15.setTransform(0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},3).to({state:[{t:this.instance_11}]},3).to({state:[{t:this.instance_12}]},3).to({state:[{t:this.instance_13}]},3).to({state:[{t:this.instance_14}]},3).to({state:[{t:this.instance_15}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,2,350,350);


(lib.talkBoxAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// textBox
	this.talkTextBox = new cjs.Text("", "24px 'Arial'");
	this.talkTextBox.name = "talkTextBox";
	this.talkTextBox.textAlign = "center";
	this.talkTextBox.lineHeight = 27;
	this.talkTextBox.lineWidth = 396;
	this.talkTextBox.parent = this;
	this.talkTextBox.setTransform(218,14);

	this.timeline.addTween(cjs.Tween.get(this.talkTextBox).wait(1));

	// bg
	this.instance = new lib.组110();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.talkBoxAni, new cjs.Rectangle(0,0,437,139), null);


(lib.swordAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0();
	this.instance.parent = this;

	this.instance_1 = new lib._1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,0,0.909,0.909);

	this.instance_2 = new lib._2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0,0,0.909,0.909);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},6).to({state:[{t:this.instance_2}]},6).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,200,200);


(lib.sword2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0png复制();
	this.instance.parent = this;

	this.instance_1 = new lib._1png复制();
	this.instance_1.parent = this;

	this.instance_2 = new lib._2png复制();
	this.instance_2.parent = this;

	this.instance_3 = new lib._3();
	this.instance_3.parent = this;

	this.instance_4 = new lib._4();
	this.instance_4.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,220,220);


(lib.sword = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.sword, null, null);


(lib.p2_name_ani = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// p2DragonName
	this.text_p2_dragon_name = new cjs.Text("渣渣龙", "30px 'Arial'", "#FFFFFF");
	this.text_p2_dragon_name.name = "text_p2_dragon_name";
	this.text_p2_dragon_name.textAlign = "center";
	this.text_p2_dragon_name.lineHeight = 32;
	this.text_p2_dragon_name.lineWidth = 236;
	this.text_p2_dragon_name.parent = this;
	this.text_p2_dragon_name.setTransform(168,50);

	this.timeline.addTween(cjs.Tween.get(this.text_p2_dragon_name).wait(1));

	// p2Name
	this.text_p2_name = new cjs.Text("PrettyBoy", "30px 'Arial'", "#FFFFFF");
	this.text_p2_name.name = "text_p2_name";
	this.text_p2_name.textAlign = "center";
	this.text_p2_name.lineHeight = 36;
	this.text_p2_name.lineWidth = 236;
	this.text_p2_name.parent = this;
	this.text_p2_name.setTransform(168,10);

	this.timeline.addTween(cjs.Tween.get(this.text_p2_name).wait(1));

	// bg
	this.instance = new lib.bg_p2_name();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.p2_name_ani, new cjs.Rectangle(0,0,288,100), null);


(lib.p1_name_ani = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// p1DragonName
	this.text_p1_dragon_name = new cjs.Text("Kai", "30px 'Arial'", "#FFFFFF");
	this.text_p1_dragon_name.name = "text_p1_dragon_name";
	this.text_p1_dragon_name.textAlign = "center";
	this.text_p1_dragon_name.lineHeight = 36;
	this.text_p1_dragon_name.lineWidth = 236;
	this.text_p1_dragon_name.parent = this;
	this.text_p1_dragon_name.setTransform(120,50);

	this.timeline.addTween(cjs.Tween.get(this.text_p1_dragon_name).wait(1));

	// p1Name
	this.text_p1_name = new cjs.Text("Don's", "30px 'Arial'", "#FFFFFF");
	this.text_p1_name.name = "text_p1_name";
	this.text_p1_name.textAlign = "center";
	this.text_p1_name.lineHeight = 36;
	this.text_p1_name.lineWidth = 236;
	this.text_p1_name.parent = this;
	this.text_p1_name.setTransform(120,10);

	this.timeline.addTween(cjs.Tween.get(this.text_p1_name).wait(1));

	// bg
	this.instance = new lib.bg_p1_name();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.p1_name_ani, new cjs.Rectangle(0,0,311,100), null);


(lib.乐器龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制10();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制10();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制10();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制10();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制10();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制10();
	this.instance_5.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.nameBoxAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// text
	this.nameTextBox = new cjs.Text("", "30px 'Arial'", "#FFFFFF");
	this.nameTextBox.name = "nameTextBox";
	this.nameTextBox.textAlign = "center";
	this.nameTextBox.lineHeight = 34;
	this.nameTextBox.lineWidth = 531;
	this.nameTextBox.parent = this;
	this.nameTextBox.setTransform(267.5,19);

	this.timeline.addTween(cjs.Tween.get(this.nameTextBox).wait(1));

	// bg
	this.instance = new lib.组55拷贝png复制();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nameBoxAni, new cjs.Rectangle(0,0,535,72), null);


(lib.nameBg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.winnerName = new cjs.Text("", "32px 'Arial'", "#FFFFFF");
	this.winnerName.name = "winnerName";
	this.winnerName.textAlign = "center";
	this.winnerName.lineHeight = 36;
	this.winnerName.lineWidth = 531;
	this.winnerName.parent = this;
	this.winnerName.setTransform(267.5,16.9);

	this.instance = new lib.组55拷贝();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.winnerName}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.nameBg, new cjs.Rectangle(0,0,535,72), null);


(lib.lightPng = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.椭圆550();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.lightPng, new cjs.Rectangle(0,0,680,680), null);


(lib.ZJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.ZJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ZJ_1, new cjs.Rectangle(0,0,46,24), null);


(lib.xyls_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.xyls();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.xyls_1, new cjs.Rectangle(0,0,98,24), null);


(lib.xyfz_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.xyfz();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.xyfz_1, new cjs.Rectangle(0,0,95,23), null);


(lib.XLFZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.XLFZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.XLFZ_1, new cjs.Rectangle(0,0,96,23), null);


(lib.XFT_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.XFT();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.XFT_1, new cjs.Rectangle(0,0,73,23), null);


(lib.TXZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.TXZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TXZ_1, new cjs.Rectangle(0,0,73,23), null);


(lib.TX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.TX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TX_1, new cjs.Rectangle(0,0,47,24), null);


(lib.TMLXQ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.TMLXQ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TMLXQ_1, new cjs.Rectangle(0,0,120,23), null);


(lib.TDBWQ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.TDBWQ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TDBWQ_1, new cjs.Rectangle(0,0,120,23), null);


(lib.TCZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.TCZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.TCZ_1, new cjs.Rectangle(0,0,72,24), null);


(lib.Taurus_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Taurus_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Taurus_2, new cjs.Rectangle(0,0,73,24), null);


(lib.SYZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SYZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SYZ_1, new cjs.Rectangle(0,0,73,24), null);


(lib.SX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SX_1, new cjs.Rectangle(0,0,46,23), null);


(lib.Switch_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Switch();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Switch_1, new cjs.Rectangle(0,0,95,23), null);


(lib.superpowers_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.superpowers();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.superpowers_1, new cjs.Rectangle(0,0,69,24), null);


(lib.SSZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SSZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SSZ_1, new cjs.Rectangle(0,0,73,24), null);


(lib.SPZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SPZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SPZ_1, new cjs.Rectangle(0,0,73,23), null);


(lib.SLZ_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SLZ_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SLZ_1_1, new cjs.Rectangle(0,0,71,24), null);


(lib.SLZ_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SLZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SLZ_2, new cjs.Rectangle(0,0,71,23), null);


(lib.SDFB_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SDFB();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SDFB_1, new cjs.Rectangle(0,0,94,24), null);


(lib.RSD_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.RSD();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.RSD_1, new cjs.Rectangle(0,0,73,23), null);


(lib.PS5_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.PS5();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PS5_1, new cjs.Rectangle(0,0,64,23), null);


(lib.P009_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P009();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P009_1, new cjs.Rectangle(0,0,5,5), null);


(lib.P008_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P008();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P008_1, new cjs.Rectangle(0,0,13,5), null);


(lib.P007_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P007();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P007_1, new cjs.Rectangle(0,0,16,5), null);


(lib.P006_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P006();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P006_1, new cjs.Rectangle(0,0,13,5), null);


(lib.P005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P005();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P005_1, new cjs.Rectangle(0,0,12,5), null);


(lib.P004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P004();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P004_1, new cjs.Rectangle(0,0,5,5), null);


(lib.P003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P003();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P003_1, new cjs.Rectangle(0,0,5,5), null);


(lib.P002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P002();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P002_1, new cjs.Rectangle(0,0,7,5), null);


(lib.P001_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P001_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P001_1_1, new cjs.Rectangle(0,0,5,5), null);


(lib.P001_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.P001();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.P001_2, new cjs.Rectangle(0,0,5,5), null);


(lib.MX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MX_1, new cjs.Rectangle(0,0,46,23), null);


(lib.MJZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MJZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MJZ_1, new cjs.Rectangle(0,0,73,23), null);


(lib.MJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MJ_1, new cjs.Rectangle(0,0,48,24), null);


(lib.MHB_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MHB();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MHB_1, new cjs.Rectangle(0,0,73,23), null);


(lib.MFGJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MFGJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MFGJ_1, new cjs.Rectangle(0,0,95,24), null);


(lib.LZGJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.LZGJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.LZGJ_1, new cjs.Rectangle(0,0,96,23), null);


(lib.LYMXGWK_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.LYMXGWK();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.LYMXGWK_1, new cjs.Rectangle(0,0,171,24), null);


(lib.LX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.LX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.LX_1, new cjs.Rectangle(0,0,46,23), null);


(lib.LHJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.LHJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.LHJ_1, new cjs.Rectangle(0,0,71,24), null);


(lib.Leo_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Leo_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Leo_2, new cjs.Rectangle(0,0,73,23), null);


(lib.JZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.JZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.JZ_1, new cjs.Rectangle(0,0,46,23), null);


(lib.JXZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.JXZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.JXZ_1, new cjs.Rectangle(0,0,71,23), null);


(lib.JX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.JX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.JX_1, new cjs.Rectangle(0,0,47,24), null);


(lib.HX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.HX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.HX_1, new cjs.Rectangle(0,0,46,24), null);


(lib.GM_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.GM();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.GM_1, new cjs.Rectangle(0,0,46,24), null);


(lib.Gemini_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Gemini_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Gemini_2, new cjs.Rectangle(0,0,72,24), null);


(lib.FY_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.FY();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FY_1, new cjs.Rectangle(0,0,47,24), null);


(lib.FXCL_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.FXCL();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FXCL_1, new cjs.Rectangle(0,0,97,23), null);


(lib.FLZT_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.FLZT();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FLZT_1, new cjs.Rectangle(0,0,97,23), null);


(lib.FDC_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.FDC();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FDC_1, new cjs.Rectangle(0,0,73,23), null);


(lib.dyzh02_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.dyzh02();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.dyzh02_1, new cjs.Rectangle(0,0,96,23), null);


(lib.dyzh_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.dyzh();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.dyzh_1, new cjs.Rectangle(0,0,95,23), null);


(lib.DXZDTGJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DXZDTGJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DXZDTGJ_1, new cjs.Rectangle(0,0,169,24), null);


(lib.DXZDDGJ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DXZDDGJ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DXZDDGJ_1, new cjs.Rectangle(0,0,169,24), null);


(lib.DRBDQ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DRBDQ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DRBDQ_1, new cjs.Rectangle(0,0,118,23), null);


(lib.DGJG_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DGJG();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DGJG_1, new cjs.Rectangle(0,0,97,23), null);


(lib.CX_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.CX();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CX_1, new cjs.Rectangle(0,0,46,23), null);


(lib.CNZ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.CNZ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CNZ_1, new cjs.Rectangle(0,0,73,24), null);


(lib.BXCTLB_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BXCTLB();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BXCTLB_1, new cjs.Rectangle(0,0,145,24), null);


(lib.BSLB_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BSLB();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BSLB_1, new cjs.Rectangle(0,0,98,24), null);


(lib.BSDH_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BSDH();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BSDH_1, new cjs.Rectangle(0,0,97,23), null);


(lib.blws_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.blws();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.blws_1, new cjs.Rectangle(0,0,98,24), null);


(lib.BDQ_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BDQ();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BDQ_1, new cjs.Rectangle(0,0,71,23), null);


(lib.Aries_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Aries_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Aries_2, new cjs.Rectangle(0,0,69,24), null);


(lib.AirPodsPro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.AirPodsPro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.AirPodsPro_1, new cjs.Rectangle(0,0,156,24), null);


(lib._23BG_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib._23BG();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib._23BG_1, new cjs.Rectangle(0,0,152,42), null);


(lib._20Y_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib._20Y();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib._20Y_1, new cjs.Rectangle(0,0,112,24), null);


(lib._7BG_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib._7BG();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib._7BG_1, new cjs.Rectangle(0,0,201,42), null);


(lib._5BG_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib._5BG();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib._5BG_1, new cjs.Rectangle(0,0,192,42), null);


(lib._4BG_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib._4BG();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib._4BG_1, new cjs.Rectangle(0,0,152,42), null);


(lib.BG001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BG001();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BG001_1, new cjs.Rectangle(0,0,596,807), null);


(lib.iconPk = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.icon_pk();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.iconPk, new cjs.Rectangle(0,0,122,122), null);


(lib.fireAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0png复制4();
	this.instance.parent = this;

	this.instance_1 = new lib._1png复制4();
	this.instance_1.parent = this;

	this.instance_2 = new lib._2png复制4();
	this.instance_2.parent = this;

	this.instance_3 = new lib._3png复制3();
	this.instance_3.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},4).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_3}]},4).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,220,220);


(lib.fire2Ani = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0png复制5();
	this.instance.parent = this;

	this.instance_1 = new lib._1png复制5();
	this.instance_1.parent = this;

	this.instance_2 = new lib._2png复制5();
	this.instance_2.parent = this;

	this.instance_3 = new lib._3png复制4();
	this.instance_3.parent = this;

	this.instance_4 = new lib._4png复制2();
	this.instance_4.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},4).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_3}]},4).to({state:[{t:this.instance_4}]},4).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,220,220);


(lib.dragon_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.冲浪龙1();
	this.instance.parent = this;

	this.instance_1 = new lib.冲浪龙2();
	this.instance_1.parent = this;

	this.instance_2 = new lib.冲浪龙3();
	this.instance_2.parent = this;

	this.instance_3 = new lib.冲浪龙4();
	this.instance_3.parent = this;

	this.instance_4 = new lib.冲浪龙5();
	this.instance_4.parent = this;

	this.instance_5 = new lib.冲浪龙6();
	this.instance_5.parent = this;

	this.instance_6 = new lib.冲浪龙7();
	this.instance_6.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.downloadPopDragonWrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.downloadPopDragonWrap, null, null);


(lib.Эхоудар_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Эхоудар();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Эхоудар_1, new cjs.Rectangle(0,0,151,42), null);


(lib.Четвернойудар_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Четвернойудар();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Четвернойудар_1, new cjs.Rectangle(0,0,232,42), null);


(lib.Цепочкаударов_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Цепочкаударов();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Цепочкаударов_1, new cjs.Rectangle(0,0,241,42), null);


(lib.Хлыстдемона_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Хлыстдемона();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Хлыстдемона_1, new cjs.Rectangle(0,0,212,42), null);


(lib.Хитрость_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Хитрость();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Хитрость_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Ударсвоздуха_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Ударсвоздуха();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Ударсвоздуха_1, new cjs.Rectangle(0,0,232,42), null);


(lib.Ударнаотмашь_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Ударнаотмашь();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Ударнаотмашь_1, new cjs.Rectangle(0,0,221,42), null);


(lib.Трава_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Трава();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Трава_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Телец_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Телец();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Телец_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Суперсила_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Суперсила();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Суперсила_1, new cjs.Rectangle(0,0,162,42), null);


(lib.Струяпламени_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Струяпламени();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Струяпламени_1, new cjs.Rectangle(0,0,217,42), null);


(lib.Стремительныйудар_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Стремительныйудар();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Стремительныйудар_1, new cjs.Rectangle(0,0,291,42), null);


(lib.Скорпион_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Скорпион();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Скорпион_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Рыбы_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Рыбы_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Рыбы_1_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Рыбы_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Рыбы();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Рыбы_2, new cjs.Rectangle(0,0,132,42), null);


(lib.РозыгрышSwitch_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.РозыгрышSwitch();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.РозыгрышSwitch_1, new cjs.Rectangle(0,0,241,43), null);


(lib.РозыгрышPS5_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.РозыгрышPS5();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.РозыгрышPS5_1, new cjs.Rectangle(0,0,202,43), null);


(lib.РозыгрышAirPodsPro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.РозыгрышAirPodsPro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.РозыгрышAirPodsPro_1, new cjs.Rectangle(0,0,292,42), null);


(lib.Рак_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Рак();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Рак_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Пробиваниеброни_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Пробиваниеброни();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Пробиваниеброни_1, new cjs.Rectangle(0,0,263,42), null);


(lib.ПодарочнаякартаAmazon_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.ПодарочнаякартаAmazon();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ПодарочнаякартаAmazon_1, new cjs.Rectangle(0,0,354,42), null);


(lib.Пламеннаяярость_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Пламеннаяярость();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Пламеннаяярость_1, new cjs.Rectangle(0,0,259,42), null);


(lib.Овен_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Овен();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Овен_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Огонь_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Огонь();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Огонь_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Небесныйвихрь_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Небесныйвихрь();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Небесныйвихрь_1, new cjs.Rectangle(0,0,232,42), null);


(lib.Мощныйпинок_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Мощныйпинок();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Мощныйпинок_1, new cjs.Rectangle(0,0,232,42), null);


(lib.Магическаяцепь_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Магическаяцепь();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Магическаяцепь_1, new cjs.Rectangle(0,0,242,42), null);


(lib.Магическаястрела_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Магическаястрела();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Магическаястрела_1, new cjs.Rectangle(0,0,256,42), null);


(lib.Лед_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Лед();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Лед_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Лев_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Лев();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Лев_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Козерог_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Козерог();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Козерог_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Каранебесная_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Каранебесная();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Каранебесная_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Камень_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Камень();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Камень_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Инстинктубийцы_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Инстинктубийцы();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Инстинктубийцы_1, new cjs.Rectangle(0,0,251,42), null);


(lib.Игровойнаборза20_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Игровойнаборза20();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Игровойнаборза20_1, new cjs.Rectangle(0,0,302,42), null);


(lib.Землетрясение_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Землетрясение();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Землетрясение_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Захватдуши_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Захватдуши();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Захватдуши_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Заряженныйудар_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Заряженныйудар_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Заряженныйудар_1_1, new cjs.Rectangle(0,0,242,42), null);


(lib.Заряженныйудар_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Заряженныйудар();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Заряженныйудар_2, new cjs.Rectangle(0,0,251,42), null);


(lib.Дождьметеоров_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Дождьметеоров();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Дождьметеоров_1, new cjs.Rectangle(0,0,232,42), null);


(lib.Дева_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Дева();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Дева_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Дезориентация_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Дезориентация();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Дезориентация_1, new cjs.Rectangle(0,0,224,42), null);


(lib.Гром_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Гром();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Гром_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Гроза_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Гроза();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Гроза_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Градискр_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Градискр();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Градискр_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Вращающийсякоготь_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Вращающийсякоготь();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Вращающийсякоготь_1, new cjs.Rectangle(0,0,301,42), null);


(lib.Вопльсмерти_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Вопльсмерти();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Вопльсмерти_1, new cjs.Rectangle(0,0,192,42), null);


(lib.Вода_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Вода();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Вода_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Водолей_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Водолей();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Водолей_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Ветер_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Ветер();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Ветер_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Весы_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Весы();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Весы_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Влепешку_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Влепешку();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Влепешку_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Божественнаястойка_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Божественнаястойка();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Божественнаястойка_1, new cjs.Rectangle(0,0,293,42), null);


(lib.Близнецы_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Близнецы();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Близнецы_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Адскийогонь_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Адскийогонь_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Адскийогонь_1_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Адскийогонь_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Адскийогонь();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Адскийогонь_2, new cjs.Rectangle(0,0,218,42), null);


(lib.Virgo_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Virgo();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Virgo_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Thunderstorm_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Thunderstorm();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Thunderstorm_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Taurus_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance_1 = new lib.Taurus();
	this.instance_1.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Taurus_3, new cjs.Rectangle(0,0,132,42), null);


(lib.SwoopingStrike_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SwoopingStrike();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SwoopingStrike_1, new cjs.Rectangle(0,0,215,42), null);


(lib.SuperStrength_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SuperStrength();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SuperStrength_1, new cjs.Rectangle(0,0,202,42), null);


(lib.SpinningClaw_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SpinningClaw();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SpinningClaw_1, new cjs.Rectangle(0,0,183,42), null);


(lib.SparkVolley_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SparkVolley();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SparkVolley_1, new cjs.Rectangle(0,0,172,42), null);


(lib.SoulPossession_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SoulPossession();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SoulPossession_1, new cjs.Rectangle(0,0,222,42), null);


(lib.SkywardSpiral_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.SkywardSpiral();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SkywardSpiral_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Scorpio_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Scorpio();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Scorpio_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Sagittarius_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Sagittarius();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Sagittarius_1, new cjs.Rectangle(0,0,142,42), null);


(lib.Roundhouse_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Roundhouse();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Roundhouse_1, new cjs.Rectangle(0,0,171,42), null);


(lib.QuickCrush_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.QuickCrush();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.QuickCrush_1, new cjs.Rectangle(0,0,202,42), null);


(lib.QuadrupleHit_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.QuadrupleHit();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.QuadrupleHit_1, new cjs.Rectangle(0,0,192,42), null);


(lib.Pyro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Pyro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Pyro_1, new cjs.Rectangle(0,0,152,42), null);


(lib.PowerPuncture_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.PowerPuncture();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PowerPuncture_1, new cjs.Rectangle(0,0,222,42), null);


(lib.PowerKick_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.PowerKick();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PowerKick_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Pisces_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Pisces();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Pisces_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Outwit_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Outwit();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Outwit_1, new cjs.Rectangle(0,0,152,42), null);


(lib.MeteorFire_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MeteorFire();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MeteorFire_1, new cjs.Rectangle(0,0,202,42), null);


(lib.MagicChain_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MagicChain();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MagicChain_1, new cjs.Rectangle(0,0,162,42), null);


(lib.MagicBolt_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.MagicBolt();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MagicBolt_1, new cjs.Rectangle(0,0,142,42), null);


(lib.Libra_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Libra();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Libra_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Leo_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance_1 = new lib.Leo();
	this.instance_1.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Leo_3, new cjs.Rectangle(0,0,152,42), null);


(lib.KillerInstinct_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.KillerInstinct();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.KillerInstinct_1, new cjs.Rectangle(0,0,182,42), null);


(lib.Hydro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Hydro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Hydro_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Hellfire3_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Hellfire3();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Hellfire3_1, new cjs.Rectangle(0,0,151,42), null);


(lib.Hellfire2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Hellfire2();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Hellfire2_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Hellfire_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Hellfire();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Hellfire_1, new cjs.Rectangle(0,0,152,42), null);


(lib.HeavensJudgement_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.HeavensJudgement();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.HeavensJudgement_1, new cjs.Rectangle(0,0,270,42), null);


(lib.Geo_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Geo();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Geo_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Gemini_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance_1 = new lib.Gemini();
	this.instance_1.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Gemini_3, new cjs.Rectangle(0,0,152,42), null);


(lib.FlamingFury_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.FlamingFury();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FlamingFury_1, new cjs.Rectangle(0,0,162,42), null);


(lib.Electro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Electro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Electro_1, new cjs.Rectangle(0,0,152,42), null);


(lib.EchoStrike_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.EchoStrike();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.EchoStrike_1, new cjs.Rectangle(0,0,152,42), null);


(lib.EarthquakeSmash_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.EarthquakeSmash();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.EarthquakeSmash_1, new cjs.Rectangle(0,0,234,42), null);


(lib.DrawbforAirPodsPro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DrawbforAirPodsPro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DrawbforAirPodsPro_1, new cjs.Rectangle(0,0,281,42), null);


(lib.DrawforSwitch_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DrawforSwitch();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DrawforSwitch_1, new cjs.Rectangle(0,0,221,42), null);


(lib.DrawforPS5_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DrawforPS5();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DrawforPS5_1, new cjs.Rectangle(0,0,192,43), null);


(lib.DivineStance_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DivineStance();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DivineStance_1, new cjs.Rectangle(0,0,172,42), null);


(lib.Disorientation_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Disorientation();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Disorientation_1, new cjs.Rectangle(0,0,202,42), null);


(lib.Dendro_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Dendro();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Dendro_1, new cjs.Rectangle(0,0,152,42), null);


(lib.DemonWhip_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DemonWhip();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DemonWhip_1, new cjs.Rectangle(0,0,182,42), null);


(lib.DeathsCry_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.DeathsCry();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.DeathsCry_1, new cjs.Rectangle(0,0,171,42), null);


(lib.Cryo_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Cryo();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Cryo_1, new cjs.Rectangle(0,0,152,42), null);


(lib.ChargedShock_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.ChargedShock();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChargedShock_1, new cjs.Rectangle(0,0,202,42), null);


(lib.ChainStrike_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.ChainStrike();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChainStrike_1, new cjs.Rectangle(0,0,152,42), null);


(lib.Capricornus_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Capricornus();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Capricornus_1, new cjs.Rectangle(0,0,162,42), null);


(lib.Cancer_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Cancer();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Cancer_1, new cjs.Rectangle(0,0,152,42), null);


(lib.BurstofFlame_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BurstofFlame();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BurstofFlame_1, new cjs.Rectangle(0,0,211,42), null);


(lib.BrutalBite_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BrutalBite_1();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BrutalBite_1_1, new cjs.Rectangle(0,0,152,42), null);


(lib.BrutalBite_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.BrutalBite();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.BrutalBite_2, new cjs.Rectangle(0,0,152,42), null);


(lib.Aries_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance_1 = new lib.Aries();
	this.instance_1.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Aries_3, new cjs.Rectangle(0,0,132,42), null);


(lib.Aquarius_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Aquarius();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Aquarius_1, new cjs.Rectangle(0,0,132,42), null);


(lib.Anemo_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Anemo();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Anemo_1, new cjs.Rectangle(0,0,132,42), null);


(lib.AmazonGiftCard_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.AmazonGiftCard();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.AmazonGiftCard_1, new cjs.Rectangle(0,0,234,42), null);


(lib.AirSlash_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.AirSlash();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.AirSlash_1, new cjs.Rectangle(0,0,132,42), null);


(lib._20GameBundle_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib._20GameBundle();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib._20GameBundle_1, new cjs.Rectangle(0,0,231,42), null);


(lib.d2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._00();
	this.instance.parent = this;

	this.instance_1 = new lib._01png复制();
	this.instance_1.parent = this;

	this.instance_2 = new lib._02png复制();
	this.instance_2.parent = this;

	this.instance_3 = new lib._03png复制();
	this.instance_3.parent = this;

	this.instance_4 = new lib._04png复制();
	this.instance_4.parent = this;

	this.instance_5 = new lib._05png复制();
	this.instance_5.parent = this;

	this.instance_6 = new lib._06png复制();
	this.instance_6.parent = this;

	this.instance_7 = new lib._07png复制();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,400,350);


(lib.元件13 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001();
	this.instance.parent = this;

	this.instance_1 = new lib._002();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008();
	this.instance_7.parent = this;

	this.instance_8 = new lib._009();
	this.instance_8.parent = this;

	this.instance_9 = new lib._010();
	this.instance_9.parent = this;

	this.instance_10 = new lib._011();
	this.instance_10.parent = this;

	this.instance_11 = new lib._012();
	this.instance_11.parent = this;

	this.instance_12 = new lib._013();
	this.instance_12.parent = this;

	this.instance_13 = new lib._014();
	this.instance_13.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_12}]},2).to({state:[{t:this.instance_13}]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.元件9 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,102,204,0)").s().p("A1FVGMAAAgqLMAqLAAAMAAAAqLg");
	this.shape.setTransform(175,175,1.297,1.297);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.元件9, new cjs.Rectangle(0,0,350,350), null);


(lib.元件7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,102,204,0)").s().p("A7VbWMAAAg2rMA2rAAAMAAAA2rg");
	this.shape.setTransform(175,175);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.元件7, new cjs.Rectangle(0,0,350,350), null);


(lib.boomAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0png复制3();
	this.instance.parent = this;

	this.instance_1 = new lib._1png复制3();
	this.instance_1.parent = this;

	this.instance_2 = new lib._2png复制3();
	this.instance_2.parent = this;

	this.instance_3 = new lib._3png复制2();
	this.instance_3.parent = this;

	this.instance_4 = new lib._4png复制();
	this.instance_4.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},4).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_3}]},4).to({state:[{t:this.instance_4}]},4).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,220,220);


(lib.boom2Ani = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0png复制2();
	this.instance.parent = this;

	this.instance_1 = new lib._1png复制2();
	this.instance_1.parent = this;

	this.instance_2 = new lib._2png复制2();
	this.instance_2.parent = this;

	this.instance_3 = new lib._3png复制();
	this.instance_3.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},4).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_3}]},4).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,220,220);


(lib.bg2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// bg
	this.instance = new lib.bg2();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.bg2_1, new cjs.Rectangle(0,0,596,807), null);


(lib.arrowAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._0png复制6();
	this.instance.parent = this;

	this.instance_1 = new lib._1png复制6();
	this.instance_1.parent = this;

	this.instance_2 = new lib._2png复制6();
	this.instance_2.parent = this;

	this.instance_3 = new lib._3png复制5();
	this.instance_3.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},4).to({state:[{t:this.instance_2}]},4).to({state:[{t:this.instance_3}]},4).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,220,220);


(lib.aaa1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(66,66,66,0)").s().p("A7VbWMAAAg2rMA2rAAAMAAAA2rg");
	this.shape.setTransform(175,175);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.aaa1, new cjs.Rectangle(0,0,350,350), null);


(lib.戴口罩龙2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制5();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制5();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制5();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制5();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制5();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制5();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制5();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制4();
	this.instance_7.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.戴口罩龙1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制4();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制4();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制4();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制4();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制4();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制4();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制4();
	this.instance_6.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.带珍珠耳环的龙 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib._001png复制3();
	this.instance.parent = this;

	this.instance_1 = new lib._002png复制3();
	this.instance_1.parent = this;

	this.instance_2 = new lib._003png复制3();
	this.instance_2.parent = this;

	this.instance_3 = new lib._004png复制3();
	this.instance_3.parent = this;

	this.instance_4 = new lib._005png复制3();
	this.instance_4.parent = this;

	this.instance_5 = new lib._006png复制3();
	this.instance_5.parent = this;

	this.instance_6 = new lib._007png复制3();
	this.instance_6.parent = this;

	this.instance_7 = new lib._008png复制3();
	this.instance_7.parent = this;

	this.instance_8 = new lib._009png复制3();
	this.instance_8.parent = this;

	this.instance_9 = new lib._010png复制3();
	this.instance_9.parent = this;

	this.instance_10 = new lib._011png复制3();
	this.instance_10.parent = this;

	this.instance_11 = new lib._012png复制3();
	this.instance_11.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},3).to({state:[{t:this.instance_11}]},3).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.RU001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Землетрясение_1();
	this.instance.parent = this;
	this.instance.setTransform(101,303,1,1,0,0,0,101,21);

	this.instance_1 = new lib.Градискр_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(542,303,1,1,0,0,0,76,21);

	this.instance_2 = new lib.Овен_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(132,21,1,1,0,0,0,66,21);

	this.instance_3 = new lib.Стремительныйудар_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(436.5,79,1,1,0,0,0,145.5,21);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,618,324);


(lib.RUGroup = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Подарочная карта Amazon
	this.instance = new lib.ПодарочнаякартаAmazon_1();
	this.instance.parent = this;
	this.instance.setTransform(7163,321,1,1,0,0,0,177,21);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Розыгрыш AirPods Pro
	this.instance_1 = new lib.РозыгрышAirPodsPro_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(7698,228,1,1,0,0,0,146,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Пламенная ярость
	this.instance_2 = new lib.Пламеннаяярость_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(7602.5,321,1,1,0,0,0,129.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Розыгрыш Switch
	this.instance_3 = new lib.РозыгрышSwitch_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(7560.5,77.5,1,1,0,0,0,120.5,21.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Рыбы
	this.instance_4 = new lib.Рыбы_2();
	this.instance_4.parent = this;
	this.instance_4.setTransform(7262,39,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// Водолей
	this.instance_5 = new lib.Водолей_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(6244,321,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	// Божественная стойка
	this.instance_6 = new lib.Божественнаястойка_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(6771.5,333,1,1,0,0,0,146.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	// Адский огонь
	this.instance_7 = new lib.Адскийогонь_2();
	this.instance_7.parent = this;
	this.instance_7.setTransform(6356,162,1,1,0,0,0,109,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(1));

	// Рыбы_1
	this.instance_8 = new lib.Рыбы_1_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(6270,39,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(1));

	// Игровой набор за $20
	this.instance_9 = new lib.Игровойнаборза20_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(6716,241,1,1,0,0,0,151,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(1));

	// Козерог
	this.instance_10 = new lib.Козерог_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(6492,97,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	// Розыгрыш PS5
	this.instance_11 = new lib.РозыгрышPS5_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(6077,244.5,1,1,0,0,0,101,21.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	// Адский огонь_1
	this.instance_12 = new lib.Адскийогонь_1_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(5574,321,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(1));

	// Весы
	this.instance_13 = new lib.Весы_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(6037,321,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(1));

	// Скорпион
	this.instance_14 = new lib.Скорпион_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(5708,162,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(1));

	// Дева
	this.instance_15 = new lib.Дева_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(5635,39,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(1));

	// Заряженный удар
	this.instance_16 = new lib.Заряженныйудар_2();
	this.instance_16.parent = this;
	this.instance_16.setTransform(5887.5,97,1,1,0,0,0,125.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(1));

	// Пробивание брони
	this.instance_17 = new lib.Пробиваниеброни_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(4868.5,321,1,1,0,0,0,131.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(1));

	// Вопль смерти
	this.instance_18 = new lib.Вопльсмерти_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(5289,321,1,1,0,0,0,96,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(1));

	// Лев
	this.instance_19 = new lib.Лев_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(5018,162,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(1));

	// Магическая цепь
	this.instance_20 = new lib.Магическаяцепь_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(4954,39,1,1,0,0,0,121,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(1));

	// Рак
	this.instance_21 = new lib.Рак_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(5121,97,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(1));

	// Захват души
	this.instance_22 = new lib.Захватдуши_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(4170,321,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_22).wait(1));

	// Близнецы
	this.instance_23 = new lib.Близнецы_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(4603,321,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(1));

	// Дезориентация
	this.instance_24 = new lib.Дезориентация_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(4284,162,1,1,0,0,0,112,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(1));

	// Телец
	this.instance_25 = new lib.Телец_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(4201,39,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_25).wait(1));

	// Хлыст демона
	this.instance_26 = new lib.Хлыстдемона_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(4393,97,1,1,0,0,0,106,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_26).wait(1));

	// Заряженный удар_1
	this.instance_27 = new lib.Заряженныйудар_1_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(3497,321,1,1,0,0,0,121,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_27).wait(1));

	// Гроза
	this.instance_28 = new lib.Гроза_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(3951,321,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(1));

	// Струя пламени
	this.instance_29 = new lib.Струяпламени_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(3667.5,162,1,1,0,0,0,108.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(1));

	// Магическая стрела
	this.instance_30 = new lib.Магическаястрела_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(3616,39,1,1,0,0,0,128,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_30).wait(1));

	// Четверной удар
	this.instance_31 = new lib.Четвернойудар_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(3888,97,1,1,0,0,0,116,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(1));

	// Кара небесная
	this.instance_32 = new lib.Каранебесная_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(2800,321,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(1));

	// Цепочка ударов
	this.instance_33 = new lib.Цепочкаударов_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(3181.5,321,1,1,0,0,0,120.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_33).wait(1));

	// Мощный пинок
	this.instance_34 = new lib.Мощныйпинок_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(2931,162,1,1,0,0,0,116,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(1));

	// Удар с воздуха
	this.instance_35 = new lib.Ударсвоздуха_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(2878,39,1,1,0,0,0,116,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(1));

	// Вращающийся коготь 
	this.instance_36 = new lib.Вращающийсякоготь_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(3153.5,97,1,1,0,0,0,150.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_36).wait(1));

	// Дождь метеоров
	this.instance_37 = new lib.Дождьметеоров_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(2136,321,1,1,0,0,0,116,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(1));

	// Эхо-удар
	this.instance_38 = new lib.Эхоудар_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(2575.5,321,1,1,0,0,0,75.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_38).wait(1));

	// Удар наотмашь 
	this.instance_39 = new lib.Ударнаотмашь_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(2309.5,162,1,1,0,0,0,110.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).wait(1));

	// Инстинкт убийцы
	this.instance_40 = new lib.Инстинктубийцы_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(2233.5,39,1,1,0,0,0,125.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).wait(1));

	// Хитрость
	this.instance_41 = new lib.Хитрость_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(2454,97,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).wait(1));

	// В лепешку
	this.instance_42 = new lib.Влепешку_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(1460,321,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_42).wait(1));

	// Суперсила
	this.instance_43 = new lib.Суперсила_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(1888,321,1,1,0,0,0,81,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_43).wait(1));

	// Ветер
	this.instance_44 = new lib.Ветер_1();
	this.instance_44.parent = this;
	this.instance_44.setTransform(1610,162,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_44).wait(1));

	// Трава
	this.instance_45 = new lib.Трава_1();
	this.instance_45.parent = this;
	this.instance_45.setTransform(1491,39,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_45).wait(1));

	// Гром
	this.instance_46 = new lib.Гром_1();
	this.instance_46.parent = this;
	this.instance_46.setTransform(1713,97,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_46).wait(1));

	// Небесный вихрь
	this.instance_47 = new lib.Небесныйвихрь_1();
	this.instance_47.parent = this;
	this.instance_47.setTransform(787,321,1,1,0,0,0,116,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_47).wait(1));

	// Огонь
	this.instance_48 = new lib.Огонь_1();
	this.instance_48.parent = this;
	this.instance_48.setTransform(1235,321,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_48).wait(1));

	// Вода
	this.instance_49 = new lib.Вода_1();
	this.instance_49.parent = this;
	this.instance_49.setTransform(952,162,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_49).wait(1));

	// Лед
	this.instance_50 = new lib.Лед_1();
	this.instance_50.parent = this;
	this.instance_50.setTransform(833,39,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_50).wait(1));

	// Камень
	this.instance_51 = new lib.Камень_1();
	this.instance_51.parent = this;
	this.instance_51.setTransform(1055,97,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_51).wait(1));

	// Землетрясение
	this.instance_52 = new lib.RU001("synched",0);
	this.instance_52.parent = this;
	this.instance_52.setTransform(8179,180,1,1,0,0,0,309,162);

	this.instance_53 = new lib.RU001("synched",0);
	this.instance_53.parent = this;
	this.instance_53.setTransform(339,180,1,1,0,0,0,309,162);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_53},{t:this.instance_52}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4,-482,8492,1651);


(lib.pkNameWrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// iconPK
	this.iconPk = new lib.iconPk();
	this.iconPk.name = "iconPk";
	this.iconPk.parent = this;
	this.iconPk.setTransform(298,63,1,1,0,0,0,61,61);
	this.iconPk.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.iconPk).wait(1));

	// p2Name
	this.p2_name_ani = new lib.p2_name_ani();
	this.p2_name_ani.name = "p2_name_ani";
	this.p2_name_ani.parent = this;
	this.p2_name_ani.setTransform(742,74,1,1,0,0,0,144,50);

	this.timeline.addTween(cjs.Tween.get(this.p2_name_ani).wait(1));

	// p1Name
	this.p1_name_ani = new lib.p1_name_ani();
	this.p1_name_ani.name = "p1_name_ani";
	this.p1_name_ani.parent = this;
	this.p1_name_ani.setTransform(-154.5,50,1,1,0,0,0,155.5,50);

	this.timeline.addTween(cjs.Tween.get(this.p1_name_ani).wait(1));

}).prototype = getMCSymbolPrototype(lib.pkNameWrap, new cjs.Rectangle(-310,0,1196,124), null);


(lib.lightAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.lightPng = new lib.lightPng();
	this.lightPng.name = "lightPng";
	this.lightPng.parent = this;
	this.lightPng.setTransform(340,340,1,1,0,0,0,340,340);

	this.timeline.addTween(cjs.Tween.get(this.lightPng).to({rotation:360},119).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,680,680);


(lib.Point = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// P001
	this.instance = new lib.P001_2();
	this.instance.parent = this;
	this.instance.setTransform(20,11.5,1,1,0,0,0,2.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({x:35.6},0).wait(2).to({x:47.5},0).wait(2));

	// P002
	this.instance_1 = new lib.P002_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(34.5,11.5,1,1,0,0,0,3.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2).to({x:46.5},0).wait(2).to({x:15},0).wait(2));

	// P003
	this.instance_2 = new lib.P003_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(47.5,17.5,1,1,0,0,0,2.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(2).to({x:15},0).wait(2).to({x:32.2},0).wait(2));

	// P004
	this.instance_3 = new lib.P004_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(34.5,34.5,1,1,0,0,0,2.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(2).to({x:2.5,y:34},0).wait(2).to({x:18.5,y:34.5},0).wait(2));

	// P005
	this.instance_4 = new lib.P005_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(16,2.5,1,1,0,0,0,6,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(2).to({x:34},0).wait(2).to({x:6},0).wait(2));

	// P006
	this.instance_5 = new lib.P006_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(34.5,19.5,1,1,0,0,0,6.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(2).to({x:43.5},0).wait(2).to({x:18},0).wait(2));

	// P007
	this.instance_6 = new lib.P007_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(26,27.5,1,1,0,0,0,8,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(2).to({x:37},0).wait(2).to({x:12},0).wait(2));

	// P008
	this.instance_7 = new lib.P008_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(22.5,34.5,1,1,0,0,0,6.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(2).to({x:38.5},0).wait(2).to({x:6.5},0).wait(2));

	// P009
	this.instance_8 = new lib.P009_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(2.5,36.5,1,1,0,0,0,2.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(2).to({x:25},0).wait(2).to({x:45},0).wait(2));

	// P001_1
	this.instance_9 = new lib.P001_1_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(6.5,32.5,1,1,0,0,0,2.5,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(2).to({x:30},0).wait(2).to({x:47.5},0).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.8,-14.9,77.1,65);


(lib.DMZJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// ZJ
	this.instance_1 = new lib.ZJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119,21,1,1,0,0,0,23,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMXZDTGJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// DXZDTGJ
	this.instance_1 = new lib.DXZDTGJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96.5,21,1,1,0,0,0,84.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMXYLS = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// xyls
	this.instance_1 = new lib.xyls_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,21,1,1,0,0,0,49,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMXYFZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// xyfz
	this.instance_1 = new lib.xyfz_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,47.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMXLFZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// XLFZ
	this.instance_1 = new lib.XLFZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,20.5,1,1,0,0,0,48,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMXFT = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// XFT
	this.instance_1 = new lib.XFT_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMXCTLP = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// BXCTLB
	this.instance_1 = new lib.BXCTLB_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96.5,21,1,1,0,0,0,72.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMTXZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// TXZ
	this.instance_1 = new lib.TXZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMTX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// TX
	this.instance_1 = new lib.TX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,23.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMTMLXQ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// TMLXQ
	this.instance_1 = new lib.TMLXQ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96,21.5,1,1,0,0,0,60,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMTDBWQ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// TDBWQ
	this.instance_1 = new lib.TDBWQ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96,21.5,1,1,0,0,0,60,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMTCZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// TCZ
	this.instance_1 = new lib.TCZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119,21,1,1,0,0,0,36,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSZZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// Leo
	this.instance_1 = new lib.Leo_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// SX
	this.instance_1 = new lib.SX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118,20.5,1,1,0,0,0,23,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSwith = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// Switch          
	this.instance_1 = new lib.Switch_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,47.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSSZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// SSZ
	this.instance_1 = new lib.SSZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,36.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSPZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// SPZ
	this.instance_1 = new lib.SPZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSLZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// SLZ
	this.instance_1 = new lib.SLZ_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,35.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSLONGZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// SLZ_1
	this.instance_1 = new lib.SLZ_1_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,35.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMSDFB = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// SDFB
	this.instance_1 = new lib.SDFB_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,21,1,1,0,0,0,47,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMRSD = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// RSD
	this.instance_1 = new lib.RSD_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMPSLB = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// BSLB
	this.instance_1 = new lib.BSLB_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,21,1,1,0,0,0,49,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMPSDH = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// BSDH
	this.instance_1 = new lib.BSDH_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,48.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMPisces = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// Pisces
	this.instance_1 = new lib.SYZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,36.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMMX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// MX
	this.instance_1 = new lib.MX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118,20.5,1,1,0,0,0,23,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMMJZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// MJZ
	this.instance_1 = new lib.MJZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMMJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// MJ
	this.instance_1 = new lib.MJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118,21,1,1,0,0,0,24,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMMHB = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// MHB
	this.instance_1 = new lib.MHB_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMMFGJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// MFGJ
	this.instance_1 = new lib.MFGJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,21,1,1,0,0,0,47.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMLZGJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// LZGJ
	this.instance_1 = new lib.LZGJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,20.5,1,1,0,0,0,48,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMLYMSGWK = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// LYMXGWK
	this.instance_1 = new lib.LYMXGWK_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(97.5,21,1,1,0,0,0,85.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMLX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// LX
	this.instance_1 = new lib.LX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118,20.5,1,1,0,0,0,23,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMLHJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// LHJ
	this.instance_1 = new lib.LHJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119.5,21,1,1,0,0,0,35.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DML20LB = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// 20Y
	this.instance_1 = new lib._20Y_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,21,1,1,0,0,0,56,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMJZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// JZ
	this.instance_1 = new lib.JZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118,20.5,1,1,0,0,0,23,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMJXZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// JXZ
	this.instance_1 = new lib.JXZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,35.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMJX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// JX
	this.instance_1 = new lib.JX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,23.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMJNZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// Taurus
	this.instance_1 = new lib.Taurus_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,36.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMHX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// HX
	this.instance_1 = new lib.HX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119,21,1,1,0,0,0,23,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMGemini = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// Gemini
	this.instance_1 = new lib.Gemini_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119,21,1,1,0,0,0,36,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMFY = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// FY
	this.instance_1 = new lib.FY_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,23.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMFXCL = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// FXCL
	this.instance_1 = new lib.FXCL_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,48.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMFTC = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// FDC
	this.instance_1 = new lib.FDC_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,36.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMFLZT = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// FLZT
	this.instance_1 = new lib.FLZT_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,48.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMDYZH02 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// dyzh02
	this.instance_1 = new lib.dyzh02_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,20.5,1,1,0,0,0,48,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMDYZH = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// dyzh
	this.instance_1 = new lib.dyzh_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,47.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMDXZDDGJ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// DXZDDGJ
	this.instance_1 = new lib.DXZDDGJ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96.5,21,1,1,0,0,0,84.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMDRBDQ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// DRBDQ
	this.instance_1 = new lib.DRBDQ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(96,21.5,1,1,0,0,0,59,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 7BG
	this.instance_2 = new lib._7BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(100.5,21,1,1,0,0,0,100.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMDGJG = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// DGJG
	this.instance_1 = new lib.DGJG_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(120.5,20.5,1,1,0,0,0,48.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMCX = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// CX
	this.instance_1 = new lib.CX_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118,20.5,1,1,0,0,0,23,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMCPS5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// PS5         
	this.instance_1 = new lib.PS5_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119,20.5,1,1,0,0,0,32,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMCNZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// CNZ
	this.instance_1 = new lib.CNZ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,36.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMCNL = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// superpowers
	this.instance_1 = new lib.superpowers_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,34.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMBYZ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// Aries
	this.instance_1 = new lib.Aries_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,21,1,1,0,0,0,34.5,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMBLWS = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// blws
	this.instance_1 = new lib.blws_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(121,21,1,1,0,0,0,49,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 4BG
	this.instance_2 = new lib._4BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMBDQ = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// BDQ
	this.instance_1 = new lib.BDQ_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(118.5,20.5,1,1,0,0,0,35.5,11.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DMAirP = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// AirPods Pro          
	this.instance_1 = new lib.AirPodsPro_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(99,21,1,1,0,0,0,78,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 5BG
	this.instance_2 = new lib._5BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(105,21,1,1,0,0,0,96,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.DM = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Point
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(202,19.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6));

	// GM
	this.instance_1 = new lib.GM_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119,21,1,1,0,0,0,23,12);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6));

	// 23BG
	this.instance_2 = new lib._23BG_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(125,21,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,42);


(lib.EN001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.EarthquakeSmash_1();
	this.instance.parent = this;
	this.instance.setTransform(117,303,1,1,0,0,0,117,21);

	this.instance_1 = new lib.SparkVolley_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(557,303,1,1,0,0,0,86,21);

	this.instance_2 = new lib.Hellfire_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(283,144,1,1,0,0,0,76,21);

	this.instance_3 = new lib.Aries_3();
	this.instance_3.parent = this;
	this.instance_3.setTransform(164,21,1,1,0,0,0,66,21);

	this.instance_4 = new lib.SwoopingStrike_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(457.5,79,1,1,0,0,0,107.5,21);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,643,324);


(lib.ENGroup = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Amazon Gift Card
	this.instance = new lib.AmazonGiftCard_1();
	this.instance.parent = this;
	this.instance.setTransform(7272,344,1,1,0,0,0,117,21);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Drawb for AirPods Pro
	this.instance_1 = new lib.DrawbforAirPodsPro_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(7750.5,252,1,1,0,0,0,140.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Flaming Fury
	this.instance_2 = new lib.FlamingFury_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(7706,344,1,1,0,0,0,81,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Draw for Switch
	this.instance_3 = new lib.DrawforSwitch_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(7420.5,185,1,1,0,0,0,110.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Pisces
	this.instance_4 = new lib.Pisces_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(7309,62,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// Brutal Bite
	this.instance_5 = new lib.BrutalBite_2();
	this.instance_5.parent = this;
	this.instance_5.setTransform(7531,120,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	// Aquarius
	this.instance_6 = new lib.Aquarius_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(6573,344,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	// Divine Stance
	this.instance_7 = new lib.DivineStance_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(6965,344,1,1,0,0,0,86,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(1));

	// Hellfire3
	this.instance_8 = new lib.Hellfire3_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(6700.5,185,1,1,0,0,0,75.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(1));

	// Sagittarius
	this.instance_9 = new lib.Sagittarius_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(6594,62,1,1,0,0,0,71,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(1));

	// $20 Game Bundle      
	this.instance_10 = new lib._20GameBundle_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(7039.5,191,1,1,0,0,0,115.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	// Capricornus
	this.instance_11 = new lib.Capricornus_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(6816,120,1,1,0,0,0,81,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	// Draw for PS5
	this.instance_12 = new lib.DrawforPS5_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(6274,267.5,1,1,0,0,0,96,21.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(1));

	// Hellfire2
	this.instance_13 = new lib.Hellfire2_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(5800,344,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(1));

	// Libra
	this.instance_14 = new lib.Libra_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(6228,344,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(1));

	// Scorpio
	this.instance_15 = new lib.Scorpio_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(5945,185,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(1));

	// Virgo
	this.instance_16 = new lib.Virgo_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(5826,62,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(1));

	// Brutal Bite_1
	this.instance_17 = new lib.BrutalBite_1_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(6048,120,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(1));

	// Power Puncture
	this.instance_18 = new lib.PowerPuncture_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(5062,344,1,1,0,0,0,111,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(1));

	// Death's Cry
	this.instance_19 = new lib.DeathsCry_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(5527.5,344,1,1,0,0,0,85.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(1));

	// Leo
	this.instance_20 = new lib.Leo_3();
	this.instance_20.parent = this;
	this.instance_20.setTransform(5252,185,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(1));

	// Magic Chain
	this.instance_21 = new lib.MagicChain_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(5139,62,1,1,0,0,0,81,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(1));

	// Cancer
	this.instance_22 = new lib.Cancer_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(5355,120,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_22).wait(1));

	// Soul Possession
	this.instance_23 = new lib.SoulPossession_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(4333,344,1,1,0,0,0,111,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(1));

	// Gemini
	this.instance_24 = new lib.Gemini_3();
	this.instance_24.parent = this;
	this.instance_24.setTransform(4776,344,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(1));

	// Disorientation
	this.instance_25 = new lib.Disorientation_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(4488,205,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_25).wait(1));

	// Taurus
	this.instance_26 = new lib.Taurus_3();
	this.instance_26.parent = this;
	this.instance_26.setTransform(4374,62,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_26).wait(1));

	// Demon Whip
	this.instance_27 = new lib.DemonWhip_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(4581,120,1,1,0,0,0,91,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_27).wait(1));

	// Charged Shock
	this.instance_28 = new lib.ChargedShock_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(3607,344,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(1));

	// Thunderstorm
	this.instance_29 = new lib.Thunderstorm_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(4015,344,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(1));

	// Burst of Flame
	this.instance_30 = new lib.BurstofFlame_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(3744.5,185,1,1,0,0,0,105.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_30).wait(1));

	// Magic Bolt
	this.instance_31 = new lib.MagicBolt_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(3633,62,1,1,0,0,0,71,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(1));

	// Quadruple Hit
	this.instance_32 = new lib.QuadrupleHit_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(3940,110,1,1,0,0,0,96,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(1));

	// Heaven's Judgement
	this.instance_33 = new lib.HeavensJudgement_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(2875,344,1,1,0,0,0,135,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_33).wait(1));

	// Chain Strike
	this.instance_34 = new lib.ChainStrike_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(3343,344,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(1));

	// Power Kick
	this.instance_35 = new lib.PowerKick_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(3060,185,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(1));

	// Air Slash
	this.instance_36 = new lib.AirSlash_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(2941,62,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_36).wait(1));

	// Spinning Claw
	this.instance_37 = new lib.SpinningClaw_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(3147.5,120,1,1,0,0,0,91.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(1));

	// Meteor Fire
	this.instance_38 = new lib.MeteorFire_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(2173,344,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_38).wait(1));

	// Echo Strike
	this.instance_39 = new lib.EchoStrike_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(2606,344,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).wait(1));

	// Roundhouse
	this.instance_40 = new lib.Roundhouse_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(2294.5,206,1,1,0,0,0,85.5,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).wait(1));

	// Killer Instinct
	this.instance_41 = new lib.KillerInstinct_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(2229,62,1,1,0,0,0,91,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).wait(1));

	// Outwit
	this.instance_42 = new lib.Outwit_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(2426,120,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_42).wait(1));

	// Quick Crush
	this.instance_43 = new lib.QuickCrush_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(1502,344,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_43).wait(1));

	// Super Strength
	this.instance_44 = new lib.SuperStrength_1();
	this.instance_44.parent = this;
	this.instance_44.setTransform(1905,344,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_44).wait(1));

	// Dendro
	this.instance_45 = new lib.Dendro_1();
	this.instance_45.parent = this;
	this.instance_45.setTransform(1653,185,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_45).wait(1));

	// Geo
	this.instance_46 = new lib.Geo_1();
	this.instance_46.parent = this;
	this.instance_46.setTransform(1534,62,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_46).wait(1));

	// Electro
	this.instance_47 = new lib.Electro_1();
	this.instance_47.parent = this;
	this.instance_47.setTransform(1756,120,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_47).wait(1));

	// Skyward Spiral
	this.instance_48 = new lib.SkywardSpiral_1();
	this.instance_48.parent = this;
	this.instance_48.setTransform(822,344,1,1,0,0,0,101,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_48).wait(1));

	// Pyro
	this.instance_49 = new lib.Pyro_1();
	this.instance_49.parent = this;
	this.instance_49.setTransform(1255,344,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_49).wait(1));

	// Hydro
	this.instance_50 = new lib.Hydro_1();
	this.instance_50.parent = this;
	this.instance_50.setTransform(972,185,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_50).wait(1));

	// Anemo
	this.instance_51 = new lib.Anemo_1();
	this.instance_51.parent = this;
	this.instance_51.setTransform(853,62,1,1,0,0,0,66,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_51).wait(1));

	// Cryo
	this.instance_52 = new lib.Cryo_1();
	this.instance_52.parent = this;
	this.instance_52.setTransform(1075,120,1,1,0,0,0,76,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_52).wait(1));

	// Earthquake Smash
	this.instance_53 = new lib.EN001("synched",0);
	this.instance_53.parent = this;
	this.instance_53.setTransform(8255,203,1,1,0,0,0,321.5,162);

	this.instance_54 = new lib.EN001("synched",0);
	this.instance_54.parent = this;
	this.instance_54.setTransform(359.5,203,1,1,0,0,0,321.5,162);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_54},{t:this.instance_53}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(36,-459,8540.5,1651);


(lib.effectWrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// arrow
	this.arrowAni = new lib.arrowAni();
	this.arrowAni.name = "arrowAni";
	this.arrowAni.parent = this;
	this.arrowAni.setTransform(100,100,0.909,0.909,0,0,0,110,110);
	this.arrowAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.arrowAni).wait(1));

	// fire2
	this.fire2Ani = new lib.fire2Ani();
	this.fire2Ani.name = "fire2Ani";
	this.fire2Ani.parent = this;
	this.fire2Ani.setTransform(100,100,0.909,0.909,0,0,0,110,110);
	this.fire2Ani.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.fire2Ani).wait(1));

	// fire
	this.fireAni = new lib.fireAni();
	this.fireAni.name = "fireAni";
	this.fireAni.parent = this;
	this.fireAni.setTransform(100,100,0.909,0.909,0,0,0,110,110);
	this.fireAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.fireAni).wait(1));

	// boom2
	this.boom2Ani = new lib.boom2Ani();
	this.boom2Ani.name = "boom2Ani";
	this.boom2Ani.parent = this;
	this.boom2Ani.setTransform(100,100,0.909,0.909,0,0,0,110,110);
	this.boom2Ani.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.boom2Ani).wait(1));

	// boom
	this.boomAni = new lib.boomAni();
	this.boomAni.name = "boomAni";
	this.boomAni.parent = this;
	this.boomAni.setTransform(100,100,0.909,0.909,0,0,0,110,110);
	this.boomAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.boomAni).wait(1));

	// sword2
	this.sword2Ani = new lib.sword2();
	this.sword2Ani.name = "sword2Ani";
	this.sword2Ani.parent = this;
	this.sword2Ani.setTransform(100,100,0.909,0.909,0,0,0,110,110);
	this.sword2Ani.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.sword2Ani).wait(1));

	// sword
	this.swordAni = new lib.swordAni();
	this.swordAni.name = "swordAni";
	this.swordAni.parent = this;
	this.swordAni.setTransform(100,100,1,1,0,0,0,100,100);
	this.swordAni.visible = false;

	this.instance = new lib.sword();
	this.instance.parent = this;
	this.instance.setTransform(100,100,1,1,0,0,0,100,100);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.swordAni}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.effectWrap, new cjs.Rectangle(0,0,200,200), null);


(lib.downloadPopAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// myDragonWrap
	this.downloadPopDragonWrap = new lib.downloadPopDragonWrap();
	this.downloadPopDragonWrap.name = "downloadPopDragonWrap";
	this.downloadPopDragonWrap.parent = this;
	this.downloadPopDragonWrap.setTransform(302.7,406.6,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.downloadPopDragonWrap).wait(1));

	// ground
	this.instance = new lib.ground2();
	this.instance.parent = this;
	this.instance.setTransform(50,514);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// popBg
	this.instance_1 = new lib.组28拷贝();
	this.instance_1.parent = this;
	this.instance_1.setTransform(32,74);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.downloadPopAni, new cjs.Rectangle(32,74,531,667), null);


(lib.DMGroupRU = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_62
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(8215.1,161,1,1,0,0,0,25,19.5);

	this.instance_1 = new lib.Point("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(8180.1,-65,1,1,0,0,0,25,19.5);

	this.instance_2 = new lib.Point("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(7800.1,161,1,1,0,0,0,25,19.5);

	this.instance_3 = new lib.Point("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(7795.1,-121,1,1,0,0,0,25,19.5);

	this.instance_4 = new lib.Point("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(7570.1,70,1,1,0,0,0,25,19.5);

	this.instance_5 = new lib.Point("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(7460.1,161,1,1,0,0,0,25,19.5);

	this.instance_6 = new lib.Point("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(7410.1,-82,1,1,0,0,0,25,19.5);

	this.instance_7 = new lib.Point("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(7055.1,-121,1,1,0,0,0,25,19.5);

	this.instance_8 = new lib.Point("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(7070.1,161,1,1,0,0,0,25,19.5);

	this.instance_9 = new lib.Point("synched",0);
	this.instance_9.parent = this;
	this.instance_9.setTransform(6645.1,172,1,1,0,0,0,25,19.5);

	this.instance_10 = new lib.Point("synched",0);
	this.instance_10.parent = this;
	this.instance_10.setTransform(6595.1,80,1,1,0,0,0,25,19.5);

	this.instance_11 = new lib.Point("synched",0);
	this.instance_11.parent = this;
	this.instance_11.setTransform(6295.1,-65,1,1,0,0,0,25,19.5);

	this.instance_12 = new lib.Point("synched",0);
	this.instance_12.parent = this;
	this.instance_12.setTransform(6190.1,0,1,1,0,0,0,25,19.5);

	this.instance_13 = new lib.Point("synched",0);
	this.instance_13.parent = this;
	this.instance_13.setTransform(6065.1,-121,1,1,0,0,0,25,19.5);

	this.instance_14 = new lib.Point("synched",0);
	this.instance_14.parent = this;
	this.instance_14.setTransform(6035.1,161,1,1,0,0,0,25,19.5);

	this.instance_15 = new lib.Point("synched",0);
	this.instance_15.parent = this;
	this.instance_15.setTransform(5905.1,85,1,1,0,0,0,25,19.5);

	this.instance_16 = new lib.Point("synched",0);
	this.instance_16.parent = this;
	this.instance_16.setTransform(5840.1,161,1,1,0,0,0,25,19.5);

	this.instance_17 = new lib.Point("synched",0);
	this.instance_17.parent = this;
	this.instance_17.setTransform(5740.1,-65,1,1,0,0,0,25,19.5);

	this.instance_18 = new lib.Point("synched",0);
	this.instance_18.parent = this;
	this.instance_18.setTransform(5430.1,-121,1,1,0,0,0,25,19.5);

	this.instance_19 = new lib.Point("synched",0);
	this.instance_19.parent = this;
	this.instance_19.setTransform(5510.1,0,1,1,0,0,0,25,19.5);

	this.instance_20 = new lib.Point("synched",0);
	this.instance_20.parent = this;
	this.instance_20.setTransform(5405.1,161,1,1,0,0,0,25,19.5);

	this.instance_21 = new lib.Point("synched",0);
	this.instance_21.parent = this;
	this.instance_21.setTransform(5115.1,161,1,1,0,0,0,25,19.5);

	this.instance_22 = new lib.Point("synched",0);
	this.instance_22.parent = this;
	this.instance_22.setTransform(4925.1,-65,1,1,0,0,0,25,19.5);

	this.instance_23 = new lib.Point("synched",0);
	this.instance_23.parent = this;
	this.instance_23.setTransform(4800.1,-121,1,1,0,0,0,25,19.5);

	this.instance_24 = new lib.Point("synched",0);
	this.instance_24.parent = this;
	this.instance_24.setTransform(4825.1,0,1,1,0,0,0,25,19.5);

	this.instance_25 = new lib.Point("synched",0);
	this.instance_25.parent = this;
	this.instance_25.setTransform(4725.1,161,1,1,0,0,0,25,19.5);

	this.instance_26 = new lib.Point("synched",0);
	this.instance_26.parent = this;
	this.instance_26.setTransform(4405.1,161,1,1,0,0,0,25,19.5);

	this.instance_27 = new lib.Point("synched",0);
	this.instance_27.parent = this;
	this.instance_27.setTransform(4230.1,-65,1,1,0,0,0,25,19.5);

	this.instance_28 = new lib.Point("synched",0);
	this.instance_28.parent = this;
	this.instance_28.setTransform(4125.1,0,1,1,0,0,0,25,19.5);

	this.instance_29 = new lib.Point("synched",0);
	this.instance_29.parent = this;
	this.instance_29.setTransform(3995.1,-121,1,1,0,0,0,25,19.5);

	this.instance_30 = new lib.Point("synched",0);
	this.instance_30.parent = this;
	this.instance_30.setTransform(3995.1,161,1,1,0,0,0,25,19.5);

	this.instance_31 = new lib.Point("synched",0);
	this.instance_31.parent = this;
	this.instance_31.setTransform(3755.1,161,1,1,0,0,0,25,19.5);

	this.instance_32 = new lib.Point("synched",0);
	this.instance_32.parent = this;
	this.instance_32.setTransform(3730.1,-65,1,1,0,0,0,25,19.5);

	this.instance_33 = new lib.Point("synched",0);
	this.instance_33.parent = this;
	this.instance_33.setTransform(3505.1,0,1,1,0,0,0,25,19.5);

	this.instance_34 = new lib.Point("synched",0);
	this.instance_34.parent = this;
	this.instance_34.setTransform(3475.1,-121,1,1,0,0,0,25,19.5);

	this.instance_35 = new lib.Point("synched",0);
	this.instance_35.parent = this;
	this.instance_35.setTransform(3345.1,161,1,1,0,0,0,25,19.5);

	this.instance_36 = new lib.Point("synched",0);
	this.instance_36.parent = this;
	this.instance_36.setTransform(3030.1,161,1,1,0,0,0,25,19.5);

	this.instance_37 = new lib.Point("synched",0);
	this.instance_37.parent = this;
	this.instance_37.setTransform(3030.1,-65,1,1,0,0,0,25,19.5);

	this.instance_38 = new lib.Point("synched",0);
	this.instance_38.parent = this;
	this.instance_38.setTransform(2775.1,5,1,1,0,0,0,25,19.5);

	this.instance_39 = new lib.Point("synched",0);
	this.instance_39.parent = this;
	this.instance_39.setTransform(2720.1,-121,1,1,0,0,0,25,19.5);

	this.instance_40 = new lib.Point("synched",0);
	this.instance_40.parent = this;
	this.instance_40.setTransform(2625.1,161,1,1,0,0,0,25,19.5);

	this.instance_41 = new lib.Point("synched",0);
	this.instance_41.parent = this;
	this.instance_41.setTransform(2380.1,161,1,1,0,0,0,25,19.5);

	this.instance_42 = new lib.Point("synched",0);
	this.instance_42.parent = this;
	this.instance_42.setTransform(2255.1,-65,1,1,0,0,0,25,19.5);

	this.instance_43 = new lib.Point("synched",0);
	this.instance_43.parent = this;
	this.instance_43.setTransform(2150.1,0,1,1,0,0,0,25,19.5);

	this.instance_44 = new lib.Point("synched",0);
	this.instance_44.parent = this;
	this.instance_44.setTransform(2085.1,-121,1,1,0,0,0,25,19.5);

	this.instance_45 = new lib.Point("synched",0);
	this.instance_45.parent = this;
	this.instance_45.setTransform(1980.1,161,1,1,0,0,0,25,19.5);

	this.instance_46 = new lib.Point("synched",0);
	this.instance_46.parent = this;
	this.instance_46.setTransform(1695.1,161,1,1,0,0,0,25,19.5);

	this.instance_47 = new lib.Point("synched",0);
	this.instance_47.parent = this;
	this.instance_47.setTransform(1520.1,-60,1,1,0,0,0,25,19.5);

	this.instance_48 = new lib.Point("synched",0);
	this.instance_48.parent = this;
	this.instance_48.setTransform(1415.1,5,1,1,0,0,0,25,19.5);

	this.instance_49 = new lib.Point("synched",0);
	this.instance_49.parent = this;
	this.instance_49.setTransform(1285.1,-121,1,1,0,0,0,25,19.5);

	this.instance_50 = new lib.Point("synched",0);
	this.instance_50.parent = this;
	this.instance_50.setTransform(1290.1,161,1,1,0,0,0,25,19.5);

	this.instance_51 = new lib.Point("synched",0);
	this.instance_51.parent = this;
	this.instance_51.setTransform(1040.1,161,1,1,0,0,0,25,19.5);

	this.instance_52 = new lib.Point("synched",0);
	this.instance_52.parent = this;
	this.instance_52.setTransform(855.1,-65,1,1,0,0,0,25,19.5);

	this.instance_53 = new lib.Point("synched",0);
	this.instance_53.parent = this;
	this.instance_53.setTransform(755.1,0,1,1,0,0,0,25,19.5);

	this.instance_54 = new lib.Point("synched",0);
	this.instance_54.parent = this;
	this.instance_54.setTransform(625.1,-121,1,1,0,0,0,25,19.5);

	this.instance_55 = new lib.Point("synched",0);
	this.instance_55.parent = this;
	this.instance_55.setTransform(630.1,165,1,1,0,0,0,25,19.5);

	this.instance_56 = new lib.Point("synched",0);
	this.instance_56.parent = this;
	this.instance_56.setTransform(375.1,161,1,1,0,0,0,25,19.5);

	this.instance_57 = new lib.Point("synched",0);
	this.instance_57.parent = this;
	this.instance_57.setTransform(340.1,-65,1,1,0,0,0,25,19.5);

	this.instance_58 = new lib.Point("synched",0);
	this.instance_58.parent = this;
	this.instance_58.setTransform(-44.9,-121,1,1,0,0,0,25,19.5);

	this.instance_59 = new lib.Point("synched",0);
	this.instance_59.parent = this;
	this.instance_59.setTransform(-40.9,161,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(6));

	// RU
	this.instance_60 = new lib.RUGroup("synched",0);
	this.instance_60.parent = this;
	this.instance_60.setTransform(3648,184.5,1,1,0,0,0,3920,343.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_60).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-242,-141,8482.1,336);


(lib.DMGroupEN = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_3
	this.instance = new lib.Point("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(8300.5,163.5,1,1,0,0,0,25,19.5);

	this.instance_1 = new lib.Point("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(8220.5,-60,1,1,0,0,0,25,19.5);

	this.instance_2 = new lib.Point("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(8015.5,5,1,1,0,0,0,25,19.5);

	this.instance_3 = new lib.Point("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(7885.5,163.5,1,1,0,0,0,25,19.5);

	this.instance_4 = new lib.Point("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(7890.5,-119.5,1,1,0,0,0,25,19.5);

	this.instance_5 = new lib.Point("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(405,163.5,1,1,0,0,0,25,19.5);

	this.instance_6 = new lib.Point("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(325,-60,1,1,0,0,0,25,19.5);

	this.instance_7 = new lib.Point("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(120,5,1,1,0,0,0,25,19.5);

	this.instance_8 = new lib.Point("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(-10,163.5,1,1,0,0,0,25,19.5);

	this.instance_9 = new lib.Point("synched",0);
	this.instance_9.parent = this;
	this.instance_9.setTransform(-5,-119.5,1,1,0,0,0,25,19.5);

	this.instance_10 = new lib.Point("synched",0);
	this.instance_10.parent = this;
	this.instance_10.setTransform(7615,70,1,1,0,0,0,25,19.5);

	this.instance_11 = new lib.Point("synched",0);
	this.instance_11.parent = this;
	this.instance_11.setTransform(7510,164,1,1,0,0,0,25,19.5);

	this.instance_12 = new lib.Point("synched",0);
	this.instance_12.parent = this;
	this.instance_12.setTransform(7325,-60,1,1,0,0,0,25,19.5);

	this.instance_13 = new lib.Point("synched",0);
	this.instance_13.parent = this;
	this.instance_13.setTransform(7250,5,1,1,0,0,0,25,19.5);

	this.instance_14 = new lib.Point("synched",0);
	this.instance_14.parent = this;
	this.instance_14.setTransform(7095,-119,1,1,0,0,0,25,19.5);

	this.instance_15 = new lib.Point("synched",0);
	this.instance_15.parent = this;
	this.instance_15.setTransform(7110,164,1,1,0,0,0,25,19.5);

	this.instance_16 = new lib.Point("synched",0);
	this.instance_16.parent = this;
	this.instance_16.setTransform(6875,10,1,1,0,0,0,25,19.5);

	this.instance_17 = new lib.Point("synched",0);
	this.instance_17.parent = this;
	this.instance_17.setTransform(6770,164,1,1,0,0,0,25,19.5);

	this.instance_18 = new lib.Point("synched",0);
	this.instance_18.parent = this;
	this.instance_18.setTransform(6620,-60,1,1,0,0,0,25,19.5);

	this.instance_19 = new lib.Point("synched",0);
	this.instance_19.parent = this;
	this.instance_19.setTransform(6495,5,1,1,0,0,0,25,19.5);

	this.instance_20 = new lib.Point("synched",0);
	this.instance_20.parent = this;
	this.instance_20.setTransform(6385,-119,1,1,0,0,0,25,19.5);

	this.instance_21 = new lib.Point("synched",0);
	this.instance_21.parent = this;
	this.instance_21.setTransform(6360,164,1,1,0,0,0,25,19.5);

	this.instance_22 = new lib.Point("synched",0);
	this.instance_22.parent = this;
	this.instance_22.setTransform(6090,85,1,1,0,0,0,25,19.5);

	this.instance_23 = new lib.Point("synched",0);
	this.instance_23.parent = this;
	this.instance_23.setTransform(6025,164,1,1,0,0,0,25,19.5);

	this.instance_24 = new lib.Point("synched",0);
	this.instance_24.parent = this;
	this.instance_24.setTransform(5845,-60,1,1,0,0,0,25,19.5);

	this.instance_25 = new lib.Point("synched",0);
	this.instance_25.parent = this;
	this.instance_25.setTransform(5740,5,1,1,0,0,0,25,19.5);

	this.instance_26 = new lib.Point("synched",0);
	this.instance_26.parent = this;
	this.instance_26.setTransform(5610,-119,1,1,0,0,0,25,19.5);

	this.instance_27 = new lib.Point("synched",0);
	this.instance_27.parent = this;
	this.instance_27.setTransform(5585,164,1,1,0,0,0,25,19.5);

	this.instance_28 = new lib.Point("synched",0);
	this.instance_28.parent = this;
	this.instance_28.setTransform(5335,164,1,1,0,0,0,25,19.5);

	this.instance_29 = new lib.Point("synched",0);
	this.instance_29.parent = this;
	this.instance_29.setTransform(5150,-60,1,1,0,0,0,25,19.5);

	this.instance_30 = new lib.Point("synched",0);
	this.instance_30.parent = this;
	this.instance_30.setTransform(5050,5,1,1,0,0,0,25,19.5);

	this.instance_31 = new lib.Point("synched",0);
	this.instance_31.parent = this;
	this.instance_31.setTransform(4940,-119,1,1,0,0,0,25,19.5);

	this.instance_32 = new lib.Point("synched",0);
	this.instance_32.parent = this;
	this.instance_32.setTransform(4895,164,1,1,0,0,0,25,19.5);

	this.instance_33 = new lib.Point("synched",0);
	this.instance_33.parent = this;
	this.instance_33.setTransform(4575,164,1,1,0,0,0,25,19.5);

	this.instance_34 = new lib.Point("synched",0);
	this.instance_34.parent = this;
	this.instance_34.setTransform(4395,-60,1,1,0,0,0,25,19.5);

	this.instance_35 = new lib.Point("synched",0);
	this.instance_35.parent = this;
	this.instance_35.setTransform(4310,25,1,1,0,0,0,25,19.5);

	this.instance_36 = new lib.Point("synched",0);
	this.instance_36.parent = this;
	this.instance_36.setTransform(4160,-119,1,1,0,0,0,25,19.5);

	this.instance_37 = new lib.Point("synched",0);
	this.instance_37.parent = this;
	this.instance_37.setTransform(4165,164,1,1,0,0,0,25,19.5);

	this.instance_38 = new lib.Point("synched",0);
	this.instance_38.parent = this;
	this.instance_38.setTransform(3835,164,1,1,0,0,0,25,19.5);

	this.instance_39 = new lib.Point("synched",0);
	this.instance_39.parent = this;
	this.instance_39.setTransform(3755,-70,1,1,0,0,0,25,19.5);

	this.instance_40 = new lib.Point("synched",0);
	this.instance_40.parent = this;
	this.instance_40.setTransform(3570,5,1,1,0,0,0,25,19.5);

	this.instance_41 = new lib.Point("synched",0);
	this.instance_41.parent = this;
	this.instance_41.setTransform(3425,-119,1,1,0,0,0,25,19.5);

	this.instance_42 = new lib.Point("synched",0);
	this.instance_42.parent = this;
	this.instance_42.setTransform(3430,164,1,1,0,0,0,25,19.5);

	this.instance_43 = new lib.Point("synched",0);
	this.instance_43.parent = this;
	this.instance_43.setTransform(3140,164,1,1,0,0,0,25,19.5);

	this.instance_44 = new lib.Point("synched",0);
	this.instance_44.parent = this;
	this.instance_44.setTransform(2960,-60,1,1,0,0,0,25,19.5);

	this.instance_45 = new lib.Point("synched",0);
	this.instance_45.parent = this;
	this.instance_45.setTransform(2855,5,1,1,0,0,0,25,19.5);

	this.instance_46 = new lib.Point("synched",0);
	this.instance_46.parent = this;
	this.instance_46.setTransform(2725,-119,1,1,0,0,0,25,19.5);

	this.instance_47 = new lib.Point("synched",0);
	this.instance_47.parent = this;
	this.instance_47.setTransform(2730,164,1,1,0,0,0,25,19.5);

	this.instance_48 = new lib.Point("synched",0);
	this.instance_48.parent = this;
	this.instance_48.setTransform(2405,164,1,1,0,0,0,25,19.5);

	this.instance_49 = new lib.Point("synched",0);
	this.instance_49.parent = this;
	this.instance_49.setTransform(2225,-60,1,1,0,0,0,25,19.5);

	this.instance_50 = new lib.Point("synched",0);
	this.instance_50.parent = this;
	this.instance_50.setTransform(2100,25,1,1,0,0,0,25,19.5);

	this.instance_51 = new lib.Point("synched",0);
	this.instance_51.parent = this;
	this.instance_51.setTransform(2040,-119,1,1,0,0,0,25,19.5);

	this.instance_52 = new lib.Point("synched",0);
	this.instance_52.parent = this;
	this.instance_52.setTransform(1995,164,1,1,0,0,0,25,19.5);

	this.instance_53 = new lib.Point("synched",0);
	this.instance_53.parent = this;
	this.instance_53.setTransform(1726,164,1,1,0,0,0,25,19.5);

	this.instance_54 = new lib.Point("synched",0);
	this.instance_54.parent = this;
	this.instance_54.setTransform(1552.6,-62,1,1,0,0,0,25,19.5);

	this.instance_55 = new lib.Point("synched",0);
	this.instance_55.parent = this;
	this.instance_55.setTransform(1450,5,1,1,0,0,0,25,19.5);

	this.instance_56 = new lib.Point("synched",0);
	this.instance_56.parent = this;
	this.instance_56.setTransform(1320,-119.5,1,1,0,0,0,25,19.5);

	this.instance_57 = new lib.Point("synched",0);
	this.instance_57.parent = this;
	this.instance_57.setTransform(1325,163.5,1,1,0,0,0,25,19.5);

	this.instance_58 = new lib.Point("synched",0);
	this.instance_58.parent = this;
	this.instance_58.setTransform(1050,163.5,1,1,0,0,0,25,19.5);

	this.instance_59 = new lib.Point("synched",0);
	this.instance_59.parent = this;
	this.instance_59.setTransform(875,-60,1,1,0,0,0,25,19.5);

	this.instance_60 = new lib.Point("synched",0);
	this.instance_60.parent = this;
	this.instance_60.setTransform(770,5,1,1,0,0,0,25,19.5);

	this.instance_61 = new lib.Point("synched",0);
	this.instance_61.parent = this;
	this.instance_61.setTransform(640,-119.5,1,1,0,0,0,25,19.5);

	this.instance_62 = new lib.Point("synched",0);
	this.instance_62.parent = this;
	this.instance_62.setTransform(645,163.5,1,1,0,0,0,25,19.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_62},{t:this.instance_61},{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(6));

	// Layer_2
	this.instance_63 = new lib.ENGroup("synched",0);
	this.instance_63.parent = this;
	this.instance_63.setTransform(3684.5,21,1,1,0,0,0,3964.5,203);

	this.timeline.addTween(cjs.Tween.get(this.instance_63).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-245,-141,9204.5,325);


(lib.DMGroup = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(6));

	// Layer_1
	this.instance = new lib.DMBLWS("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(8778,163,1,1,0,0,0,113.5,21);

	this.instance_1 = new lib.DMAirP("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(8846,71,1,1,0,0,0,113.5,21);

	this.instance_2 = new lib.DMLYMSGWK("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(8380,163,1,1,0,0,0,113.5,21);

	this.instance_3 = new lib.DMSwith("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(8500,3,1,1,0,0,0,113.5,21);

	this.instance_4 = new lib.DMXYFZ("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(8604,-62,1,1,0,0,0,113.5,21);

	this.instance_5 = new lib.DMPisces("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(8391,-120,1,1,0,0,0,113.5,21);

	this.instance_6 = new lib.DMPSLB("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(7987.3,163,1,1,0,0,0,113.5,21);

	this.instance_7 = new lib.DMAirP("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(8055.3,71,1,1,0,0,0,113.5,21);

	this.instance_8 = new lib.DMDXZDDGJ("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(7589.3,163,1,1,0,0,0,113.5,21);

	this.instance_9 = new lib.DMPSDH("synched",0);
	this.instance_9.parent = this;
	this.instance_9.setTransform(7709.3,3,1,1,0,0,0,113.5,21);

	this.instance_10 = new lib.DMFLZT("synched",0);
	this.instance_10.parent = this;
	this.instance_10.setTransform(7813.3,-62,1,1,0,0,0,113.5,21);

	this.instance_11 = new lib.DMBYZ("synched",0);
	this.instance_11.parent = this;
	this.instance_11.setTransform(7600.3,-120,1,1,0,0,0,113.5,21);

	this.instance_12 = new lib.DMHX("synched",0);
	this.instance_12.parent = this;
	this.instance_12.setTransform(7138,163,1,1,0,0,0,113.5,21);

	this.instance_13 = new lib.DMAirP("synched",0);
	this.instance_13.parent = this;
	this.instance_13.setTransform(7206,71,1,1,0,0,0,113.5,21);

	this.instance_14 = new lib.DMXZDTGJ("synched",0);
	this.instance_14.parent = this;
	this.instance_14.setTransform(6740,163,1,1,0,0,0,113.5,21);

	this.instance_15 = new lib.DMSX("synched",0);
	this.instance_15.parent = this;
	this.instance_15.setTransform(6860,3,1,1,0,0,0,113.5,21);

	this.instance_16 = new lib.DMMX("synched",0);
	this.instance_16.parent = this;
	this.instance_16.setTransform(6964,-62,1,1,0,0,0,113.5,21);

	this.instance_17 = new lib.DMJX("synched",0);
	this.instance_17.parent = this;
	this.instance_17.setTransform(6751,-120,1,1,0,0,0,113.5,21);

	this.instance_18 = new lib.DMCNL("synched",0);
	this.instance_18.parent = this;
	this.instance_18.setTransform(6323,163,1,1,0,0,0,113.5,21);

	this.instance_19 = new lib.DMAirP("synched",0);
	this.instance_19.parent = this;
	this.instance_19.setTransform(6391,71,1,1,0,0,0,113.5,21);

	this.instance_20 = new lib.DMXCTLP("synched",0);
	this.instance_20.parent = this;
	this.instance_20.setTransform(5925,163,1,1,0,0,0,113.5,21);

	this.instance_21 = new lib.DMCX("synched",0);
	this.instance_21.parent = this;
	this.instance_21.setTransform(6045,3,1,1,0,0,0,113.5,21);

	this.instance_22 = new lib.DMLX("synched",0);
	this.instance_22.parent = this;
	this.instance_22.setTransform(6149,-62,1,1,0,0,0,113.5,21);

	this.instance_23 = new lib.DMTX("synched",0);
	this.instance_23.parent = this;
	this.instance_23.setTransform(5936,-120,1,1,0,0,0,113.5,21);

	this.instance_24 = new lib.DMZJ("synched",0);
	this.instance_24.parent = this;
	this.instance_24.setTransform(5473.7,163,1,1,0,0,0,113.5,21);

	this.instance_25 = new lib.DMAirP("synched",0);
	this.instance_25.parent = this;
	this.instance_25.setTransform(5541.7,71,1,1,0,0,0,113.5,21);

	this.instance_26 = new lib.DMTMLXQ("synched",0);
	this.instance_26.parent = this;
	this.instance_26.setTransform(5075.7,163,1,1,0,0,0,113.5,21);

	this.instance_27 = new lib.DMXFT("synched",0);
	this.instance_27.parent = this;
	this.instance_27.setTransform(5195.7,3,1,1,0,0,0,113.5,21);

	this.instance_28 = new lib.DMJZ("synched",0);
	this.instance_28.parent = this;
	this.instance_28.setTransform(5299.7,-62,1,1,0,0,0,113.5,21);

	this.instance_29 = new lib.DMMJ("synched",0);
	this.instance_29.parent = this;
	this.instance_29.setTransform(5086.7,-120,1,1,0,0,0,113.5,21);

	this.instance_30 = new lib.DMLHJ("synched",0);
	this.instance_30.parent = this;
	this.instance_30.setTransform(4717.6,163,1,1,0,0,0,113.5,21);

	this.instance_31 = new lib.DM("synched",0);
	this.instance_31.parent = this;
	this.instance_31.setTransform(4785.6,71,1,1,0,0,0,113.5,21);

	this.instance_32 = new lib.DMTDBWQ("synched",0);
	this.instance_32.parent = this;
	this.instance_32.setTransform(4319.6,163,1,1,0,0,0,113.5,21);

	this.instance_33 = new lib.DMDGJG("synched",0);
	this.instance_33.parent = this;
	this.instance_33.setTransform(4439.6,3,1,1,0,0,0,113.5,21);

	this.instance_34 = new lib.DMFTC("synched",0);
	this.instance_34.parent = this;
	this.instance_34.setTransform(4543.6,-62,1,1,0,0,0,113.5,21);

	this.instance_35 = new lib.DMSLONGZ("synched",0);
	this.instance_35.parent = this;
	this.instance_35.setTransform(4330.6,-120,1,1,0,0,0,113.5,21);

	this.instance_36 = new lib.DMSDFB("synched",0);
	this.instance_36.parent = this;
	this.instance_36.setTransform(3973.4,163,1,1,0,0,0,113.5,21);

	this.instance_37 = new lib.DM("synched",0);
	this.instance_37.parent = this;
	this.instance_37.setTransform(4041.4,71,1,1,0,0,0,113.5,21);

	this.instance_38 = new lib.DMDRBDQ("synched",0);
	this.instance_38.parent = this;
	this.instance_38.setTransform(3575.4,163,1,1,0,0,0,113.5,21);

	this.instance_39 = new lib.DMRSD("synched",0);
	this.instance_39.parent = this;
	this.instance_39.setTransform(3695.4,3,1,1,0,0,0,113.5,21);

	this.instance_40 = new lib.DMSLZ("synched",0);
	this.instance_40.parent = this;
	this.instance_40.setTransform(3799.4,-62,1,1,0,0,0,113.5,21);

	this.instance_41 = new lib.DMMFGJ("synched",0);
	this.instance_41.parent = this;
	this.instance_41.setTransform(3586.4,-120,1,1,0,0,0,113.5,21);

	this.instance_42 = new lib.DMGemini("synched",0);
	this.instance_42.parent = this;
	this.instance_42.setTransform(3217.2,163,1,1,0,0,0,113.5,21);

	this.instance_43 = new lib.DM("synched",0);
	this.instance_43.parent = this;
	this.instance_43.setTransform(3285.2,71,1,1,0,0,0,113.5,21);

	this.instance_44 = new lib.DMXLFZ("synched",0);
	this.instance_44.parent = this;
	this.instance_44.setTransform(2819.2,163,1,1,0,0,0,113.5,21);

	this.instance_45 = new lib.DMFXCL("synched",0);
	this.instance_45.parent = this;
	this.instance_45.setTransform(2939.2,3,1,1,0,0,0,113.5,21);

	this.instance_46 = new lib.DMMHB("synched",0);
	this.instance_46.parent = this;
	this.instance_46.setTransform(3043.2,-62,1,1,0,0,0,113.5,21);

	this.instance_47 = new lib.DMJNZ("synched",0);
	this.instance_47.parent = this;
	this.instance_47.setTransform(2830.2,-120,1,1,0,0,0,113.5,21);

	this.instance_48 = new lib.DM("synched",0);
	this.instance_48.parent = this;
	this.instance_48.setTransform(2523,163,1,1,0,0,0,113.5,21);

	this.instance_49 = new lib.DM("synched",0);
	this.instance_49.parent = this;
	this.instance_49.setTransform(2591,71,1,1,0,0,0,113.5,21);

	this.instance_50 = new lib.DMLZGJ("synched",0);
	this.instance_50.parent = this;
	this.instance_50.setTransform(2125,163,1,1,0,0,0,113.5,21);

	this.instance_51 = new lib.DMSZZ("synched",0);
	this.instance_51.parent = this;
	this.instance_51.setTransform(2245,3,1,1,0,0,0,113.5,21);

	this.instance_52 = new lib.DMJXZ("synched",0);
	this.instance_52.parent = this;
	this.instance_52.setTransform(2349,-62,1,1,0,0,0,113.5,21);

	this.instance_53 = new lib.DMFY("synched",0);
	this.instance_53.parent = this;
	this.instance_53.setTransform(2136,-120,1,1,0,0,0,113.5,21);

	this.instance_54 = new lib.DMTCZ("synched",0);
	this.instance_54.parent = this;
	this.instance_54.setTransform(1766.9,163,1,1,0,0,0,113.5,21);

	this.instance_55 = new lib.DMCPS5("synched",0);
	this.instance_55.parent = this;
	this.instance_55.setTransform(1834.9,71,1,1,0,0,0,113.5,21);

	this.instance_56 = new lib.DMDYZH02("synched",0);
	this.instance_56.parent = this;
	this.instance_56.setTransform(1368.9,163,1,1,0,0,0,113.5,21);

	this.instance_57 = new lib.DMTXZ("synched",0);
	this.instance_57.parent = this;
	this.instance_57.setTransform(1488.9,3,1,1,0,0,0,113.5,21);

	this.instance_58 = new lib.DMBDQ("synched",0);
	this.instance_58.parent = this;
	this.instance_58.setTransform(1592.9,-62,1,1,0,0,0,113.5,21);

	this.instance_59 = new lib.DMCNZ("synched",0);
	this.instance_59.parent = this;
	this.instance_59.setTransform(1379.9,-120,1,1,0,0,0,113.5,21);

	this.instance_60 = new lib.DMXYLS("synched",0);
	this.instance_60.parent = this;
	this.instance_60.setTransform(1022.7,163,1,1,0,0,0,113.5,21);

	this.instance_61 = new lib.DML20LB("synched",0);
	this.instance_61.parent = this;
	this.instance_61.setTransform(1090.7,71,1,1,0,0,0,113.5,21);

	this.instance_62 = new lib.DMSPZ("synched",0);
	this.instance_62.parent = this;
	this.instance_62.setTransform(624.7,163,1,1,0,0,0,113.5,21);

	this.instance_63 = new lib.DMDYZH("synched",0);
	this.instance_63.parent = this;
	this.instance_63.setTransform(744.7,3,1,1,0,0,0,113.5,21);

	this.instance_64 = new lib.DMMJZ("synched",0);
	this.instance_64.parent = this;
	this.instance_64.setTransform(848.7,-62,1,1,0,0,0,113.5,21);

	this.instance_65 = new lib.DMSSZ("synched",0);
	this.instance_65.parent = this;
	this.instance_65.setTransform(635.7,-120,1,1,0,0,0,113.5,21);

	this.instance_66 = new lib.DMBLWS("synched",0);
	this.instance_66.parent = this;
	this.instance_66.setTransform(266.5,163,1,1,0,0,0,113.5,21);

	this.instance_67 = new lib.DMAirP("synched",0);
	this.instance_67.parent = this;
	this.instance_67.setTransform(334.5,71,1,1,0,0,0,113.5,21);

	this.instance_68 = new lib.DMLYMSGWK("synched",0);
	this.instance_68.parent = this;
	this.instance_68.setTransform(-131.5,163,1,1,0,0,0,113.5,21);

	this.instance_69 = new lib.DMSwith("synched",0);
	this.instance_69.parent = this;
	this.instance_69.setTransform(-11.5,3,1,1,0,0,0,113.5,21);

	this.instance_70 = new lib.DMXYFZ("synched",0);
	this.instance_70.parent = this;
	this.instance_70.setTransform(92.5,-62,1,1,0,0,0,113.5,21);

	this.instance_71 = new lib.DMPisces("synched",0);
	this.instance_71.parent = this;
	this.instance_71.setTransform(-120.5,-120,1,1,0,0,0,113.5,21);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_71},{t:this.instance_70},{t:this.instance_69},{t:this.instance_68},{t:this.instance_67},{t:this.instance_66},{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61},{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-245,-141,9204.5,325);


(lib.d19 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.玩游戏龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d19, new cjs.Rectangle(0,0,350,350), null);


(lib.d18 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.沙滩度假龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d18, new cjs.Rectangle(0,0,350,350), null);


(lib.d17 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.龙一();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d17, new cjs.Rectangle(0,0,350,350), null);


(lib.d16 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.龙五();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d16, new cjs.Rectangle(0,0,350,350), null);


(lib.d15 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.龙四();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d15, new cjs.Rectangle(0,0,350,350), null);


(lib.d14 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.龙三();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d14, new cjs.Rectangle(0,0,350,350), null);


(lib.d13 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.龙二();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d13, new cjs.Rectangle(0,0,350,350), null);


(lib.d12 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.乐器龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d12, new cjs.Rectangle(0,0,350,350), null);


(lib.d11 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.篮球龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d11, new cjs.Rectangle(0,0,350,350), null);


(lib.d10 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.喝可乐龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d10, new cjs.Rectangle(0,0,350,350), null);


(lib.d9 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.海盗龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d9, new cjs.Rectangle(0,0,350,350), null);


(lib.d8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.肥宅龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d8, new cjs.Rectangle(0,0,350,350), null);


(lib.d7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.戴口罩龙2();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d7, new cjs.Rectangle(0,0,350,350), null);


(lib.d6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.戴口罩龙1();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d6, new cjs.Rectangle(0,0,350,350), null);


(lib.d5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.带珍珠耳环的龙();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d5, new cjs.Rectangle(0,0,350,350), null);


(lib.d4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.元件13();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d4, new cjs.Rectangle(0,0,350,350), null);


(lib.d3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.instance = new lib.疫苗龙1();
	this.instance.parent = this;
	this.instance.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.d3, new cjs.Rectangle(0,0,350,350), null);


(lib.d1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.d1 = new lib.dragon_1();
	this.d1.name = "d1";
	this.d1.parent = this;
	this.d1.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.d1).wait(1));

}).prototype = getMCSymbolPrototype(lib.d1, new cjs.Rectangle(0,0,350,350), null);


(lib.d0 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// 图层_1
	this.d0 = new lib.test456();
	this.d0.name = "d0";
	this.d0.parent = this;
	this.d0.setTransform(175,175,1,1,0,0,180,175,177);

	this.timeline.addTween(cjs.Tween.get(this.d0).wait(1));

}).prototype = getMCSymbolPrototype(lib.d0, new cjs.Rectangle(0,0,350,350), null);


(lib.元件10 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_11 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_12 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_23 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11).call(this.frame_11).wait(1).call(this.frame_12).wait(11).call(this.frame_23).wait(1));

	// 图层_1
	this.instance = new lib.补间7("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(245.5,47.5);

	this.instance_1 = new lib.补间8("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(245.5,172.5);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true,y:172.5,alpha:0},11).wait(13));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:false},11).wait(1).to({startPosition:0},0).to({y:47.5,alpha:1},11).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,491,95);


(lib.元件8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_11 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_12 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_23 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11).call(this.frame_11).wait(1).call(this.frame_12).wait(11).call(this.frame_23).wait(1));

	// myDragon
	this.myAni = new lib.元件9();
	this.myAni.name = "myAni";
	this.myAni.parent = this;
	this.myAni.setTransform(175,175,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.myAni).to({y:300,alpha:0},11).wait(1).to({y:175,alpha:1},11).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,350,350);


(lib.元件5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_11 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11).call(this.frame_11).wait(1));

	// 图层_1
	this.bbb1 = new lib.元件7();
	this.bbb1.name = "bbb1";
	this.bbb1.parent = this;
	this.bbb1.setTransform(214,192.5,0.8,0.8,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.bbb1).to({x:504},11).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(74,52.5,280,280);


(lib.元件4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_11 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(11).call(this.frame_11).wait(1));

	// 图层_1
	this.aaa1 = new lib.aaa1();
	this.aaa1.name = "aaa1";
	this.aaa1.parent = this;
	this.aaa1.setTransform(610,192.5,0.8,0.8,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.aaa1).to({regX:175.1,regY:175.1,x:320.1,y:192.6},11).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(470,52.5,280,280);


(lib.winnerAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// nameBox
	this.winnerNameBox = new lib.nameBg();
	this.winnerNameBox.name = "winnerNameBox";
	this.winnerNameBox.parent = this;
	this.winnerNameBox.setTransform(301.8,675.2,1,1,0,0,0,267.5,36);

	this.timeline.addTween(cjs.Tween.get(this.winnerNameBox).wait(1));

	// dragon
	this.winnerDragonWrap = new lib.winnerDragonWrap();
	this.winnerDragonWrap.name = "winnerDragonWrap";
	this.winnerDragonWrap.parent = this;
	this.winnerDragonWrap.setTransform(301.7,464.2,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.winnerDragonWrap).wait(1));

	// winnerIcon
	this.instance = new lib.winnerIcon();
	this.instance.parent = this;
	this.instance.setTransform(298.6,153.3,1,1,0,0,0,209.5,61.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// light
	this.lightAni = new lib.lightAni();
	this.lightAni.name = "lightAni";
	this.lightAni.parent = this;
	this.lightAni.setTransform(297.1,476.5,1,1,0,0,0,340,340);

	this.timeline.addTween(cjs.Tween.get(this.lightAni).wait(1));

}).prototype = getMCSymbolPrototype(lib.winnerAni, new cjs.Rectangle(-42.9,91.8,680,724.7), null);


(lib.popupAni = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// downloadAni
	this.downloadPopAni = new lib.downloadPopAni();
	this.downloadPopAni.name = "downloadPopAni";
	this.downloadPopAni.parent = this;
	this.downloadPopAni.setTransform(298,403.5,1,1,0,0,0,298,403.5);
	this.downloadPopAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.downloadPopAni).wait(1));

	// winnerAni
	this.winnerAni = new lib.winnerAni();
	this.winnerAni.name = "winnerAni";
	this.winnerAni.parent = this;
	this.winnerAni.setTransform(297.9,403.5,1,1,0,0,0,297.9,403.5);
	this.winnerAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.winnerAni).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.698)").s().p("EgujA/DMAAAh+FMBdHAAAMAAAB+Fg");
	this.shape.setTransform(298,403.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.popupAni, new cjs.Rectangle(-42.9,0,680,816.5), null);


(lib.pk_dragon_0 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.bbbAni.stop();
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.aaaAni.stop();
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.myDragonAni.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(29));

	// talkBox
	this.talkBoxAni = new lib.talkBoxAni();
	this.talkBoxAni.name = "talkBoxAni";
	this.talkBoxAni.parent = this;
	this.talkBoxAni.setTransform(172.5,119.5,1,1,0,0,0,218.5,69.5);
	this.talkBoxAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.talkBoxAni).wait(29));

	// nameBox
	this.nameBoxAni = new lib.nameBoxAni();
	this.nameBoxAni.name = "nameBoxAni";
	this.nameBoxAni.parent = this;
	this.nameBoxAni.setTransform(173.5,-9,1,1,0,0,0,267.5,36);

	this.timeline.addTween(cjs.Tween.get(this.nameBoxAni).wait(29));

	// playerNameWrap
	this.pkNameWrap = new lib.pkNameWrap();
	this.pkNameWrap.name = "pkNameWrap";
	this.pkNameWrap.parent = this;
	this.pkNameWrap.setTransform(174.7,20.5,1,1,0,0,0,298,60);

	this.timeline.addTween(cjs.Tween.get(this.pkNameWrap).wait(29));

	// userDragon
	this.bbbAni = new lib.元件5();
	this.bbbAni.name = "bbbAni";
	this.bbbAni.parent = this;
	this.bbbAni.setTransform(-302.3,270,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.bbbAni).wait(29));

	// enemyDragon
	this.aaaAni = new lib.元件4();
	this.aaaAni.name = "aaaAni";
	this.aaaAni.parent = this;
	this.aaaAni.setTransform(175,270,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.aaaAni).wait(29));

	// pkEffect
	this.effectWrap = new lib.effectWrap();
	this.effectWrap.name = "effectWrap";
	this.effectWrap.parent = this;
	this.effectWrap.setTransform(170,100,1,1,0,0,0,100,100);

	this.timeline.addTween(cjs.Tween.get(this.effectWrap).wait(29));

	// myDragon
	this.myDragonAni = new lib.元件8();
	this.myDragonAni.name = "myDragonAni";
	this.myDragonAni.parent = this;
	this.myDragonAni.setTransform(175,220,1,1,0,0,0,175,200);

	this.timeline.addTween(cjs.Tween.get(this.myDragonAni).wait(29));

	// ground
	this.groundAni = new lib.元件10();
	this.groundAni.name = "groundAni";
	this.groundAni.parent = this;
	this.groundAni.setTransform(173.5,342.5,1,1,0,0,0,245.5,47.5);

	this.timeline.addTween(cjs.Tween.get(this.groundAni).to({_off:true},1).wait(28));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-433.3,-45,1196,472.5);


(lib.dragonWrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// dragon_19
	this.d19 = new lib.d19();
	this.d19.name = "d19";
	this.d19.parent = this;
	this.d19.setTransform(175,175,1,1,0,0,0,175,175);
	this.d19.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d19).wait(1));

	// dragon_18
	this.d18 = new lib.d18();
	this.d18.name = "d18";
	this.d18.parent = this;
	this.d18.setTransform(175,175,1,1,0,0,0,175,175);
	this.d18.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d18).wait(1));

	// dragon_17
	this.d17 = new lib.d17();
	this.d17.name = "d17";
	this.d17.parent = this;
	this.d17.setTransform(175,175,1,1,0,0,0,175,175);
	this.d17.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d17).wait(1));

	// dragon_16
	this.d16 = new lib.d16();
	this.d16.name = "d16";
	this.d16.parent = this;
	this.d16.setTransform(175,175,1,1,0,0,0,175,175);
	this.d16.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d16).wait(1));

	// dragon_15
	this.d15 = new lib.d15();
	this.d15.name = "d15";
	this.d15.parent = this;
	this.d15.setTransform(175,175,1,1,0,0,0,175,175);
	this.d15.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d15).wait(1));

	// dragon_14
	this.d14 = new lib.d14();
	this.d14.name = "d14";
	this.d14.parent = this;
	this.d14.setTransform(175,175,1,1,0,0,0,175,175);
	this.d14.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d14).wait(1));

	// dragon_13
	this.d13 = new lib.d13();
	this.d13.name = "d13";
	this.d13.parent = this;
	this.d13.setTransform(175,175,1,1,0,0,0,175,175);
	this.d13.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d13).wait(1));

	// dragon_12
	this.d12 = new lib.d12();
	this.d12.name = "d12";
	this.d12.parent = this;
	this.d12.setTransform(175,175,1,1,0,0,0,175,175);
	this.d12.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d12).wait(1));

	// dragon_11
	this.d11 = new lib.d11();
	this.d11.name = "d11";
	this.d11.parent = this;
	this.d11.setTransform(175,175,1,1,0,0,0,175,175);
	this.d11.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d11).wait(1));

	// dragon_10
	this.d10 = new lib.d10();
	this.d10.name = "d10";
	this.d10.parent = this;
	this.d10.setTransform(175,175,1,1,0,0,0,175,175);
	this.d10.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d10).wait(1));

	// dragon_9
	this.d9 = new lib.d9();
	this.d9.name = "d9";
	this.d9.parent = this;
	this.d9.setTransform(175,175,1,1,0,0,0,175,175);
	this.d9.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d9).wait(1));

	// dragon_8
	this.d8 = new lib.d8();
	this.d8.name = "d8";
	this.d8.parent = this;
	this.d8.setTransform(175,175,1,1,0,0,0,175,175);
	this.d8.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d8).wait(1));

	// dragon_7
	this.d7 = new lib.d7();
	this.d7.name = "d7";
	this.d7.parent = this;
	this.d7.setTransform(175,175,1,1,0,0,0,175,175);
	this.d7.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d7).wait(1));

	// dragon_6
	this.d6 = new lib.d6();
	this.d6.name = "d6";
	this.d6.parent = this;
	this.d6.setTransform(175,175,1,1,0,0,0,175,175);
	this.d6.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d6).wait(1));

	// dragon_5
	this.d5 = new lib.d5();
	this.d5.name = "d5";
	this.d5.parent = this;
	this.d5.setTransform(175,175,1,1,0,0,0,175,175);
	this.d5.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d5).wait(1));

	// dragon_4
	this.instance = new lib.d4();
	this.instance.parent = this;
	this.instance.setTransform(183.2,181.7,1,1,0,0,0,183.2,181.7);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// dragon_3
	this.d3 = new lib.d3();
	this.d3.name = "d3";
	this.d3.parent = this;
	this.d3.setTransform(175,175,1,1,0,0,0,175,175);
	this.d3.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d3).wait(1));

	// dragon_1
	this.d1 = new lib.d1();
	this.d1.name = "d1";
	this.d1.parent = this;
	this.d1.setTransform(175,175,1,1,0,0,0,175,175);
	this.d1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.d1).wait(1));

	// dragon_0
	this.instance_1 = new lib.d0();
	this.instance_1.parent = this;
	this.instance_1.setTransform(175,175,1,1,0,0,0,175,175);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.dragonWrap, new cjs.Rectangle(0,0,350,350), null);


(lib.dmWrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		var _this = this;
		/*
		停止播放影片剪辑/视频
		停止播放指定影片剪辑或视频。
		*/
		_this.stop();
	}
	this.frame_784 = function() {
		var _this = this;
		/*
		将播放头移动到时间轴中的指定帧编号并继续从该帧播放。
		可在主时间轴或影片剪辑时间轴上使用。
		*/
		_this.gotoAndPlay(1);
		var _this = this;
		/*
		将播放头移动到时间轴中的指定帧编号并继续从该帧播放。
		可在主时间轴或影片剪辑时间轴上使用。
		*/
		_this.gotoAndPlay(1);
		var _this = this;
		/*
		将播放头移动到时间轴中的指定帧编号并继续从该帧播放。
		可在主时间轴或影片剪辑时间轴上使用。
		*/
		_this.gotoAndPlay(1);
		var _this = this;
		/*
		将播放头移动到时间轴中的指定帧编号并继续从该帧播放。
		可在主时间轴或影片剪辑时间轴上使用。
		*/
		_this.gotoAndPlay(1);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(784).call(this.frame_784).wait(1));

	// Mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("EgtKg/CMBbQAAAMAAAB+FMhbQAAAg");
	var mask_graphics_784 = new cjs.Graphics().p("EgtKg/CMBbQAAAMAAAB+FMhbQAAAg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:295,y:403.5}).wait(784).to({graphics:mask_graphics_784,x:295,y:403.5}).wait(1));

	// DM-RU
	this.dm_ani_ru = new lib.DMGroupRU();
	this.dm_ani_ru.name = "dm_ani_ru";
	this.dm_ani_ru.parent = this;
	this.dm_ani_ru.setTransform(289,205,1,1,0,0,0,89,21);
	this.dm_ani_ru.visible = false;

	var maskedShapeInstanceList = [this.dm_ani_ru];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.dm_ani_ru).to({x:-7550.9},784).wait(1));

	// DM-EN
	this.dm_ani_en = new lib.DMGroupEN();
	this.dm_ani_en.name = "dm_ani_en";
	this.dm_ani_en.parent = this;
	this.dm_ani_en.setTransform(294,205,1,1,0,0,0,89,21);
	this.dm_ani_en.visible = false;

	var maskedShapeInstanceList = [this.dm_ani_en];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.dm_ani_en).to({x:-7601.9},784).wait(1));

	// DM-CN
	this.dm_ani_zh = new lib.DMGroup();
	this.dm_ani_zh.name = "dm_ani_zh";
	this.dm_ani_zh.parent = this;
	this.dm_ani_zh.setTransform(294,205,1,1,0,0,0,89,21);
	this.dm_ani_zh.visible = false;

	var maskedShapeInstanceList = [this.dm_ani_zh];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.dm_ani_zh).to({x:-8217.7},784).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(6,43,584.1,336);


// stage content:
(lib.anitest = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// popup
	this.popupAni = new lib.popupAni();
	this.popupAni.name = "popupAni";
	this.popupAni.parent = this;
	this.popupAni.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.popupAni).wait(1));

	// dragon_ani_wrap
	this.dragon_ani_wrap = new lib.pk_dragon_0();
	this.dragon_ani_wrap.name = "dragon_ani_wrap";
	this.dragon_ani_wrap.parent = this;
	this.dragon_ani_wrap.setTransform(298.9,266.7,1,1,0,0,0,175,175);

	this.timeline.addTween(cjs.Tween.get(this.dragon_ani_wrap).wait(1));

	// dm
	this.dmWrap = new lib.dmWrap();
	this.dmWrap.name = "dmWrap";
	this.dmWrap.parent = this;
	this.dmWrap.setTransform(298,403.4,1,1,0,0,0,298,403.4);

	this.timeline.addTween(cjs.Tween.get(this.dmWrap).wait(1));

	// dragon
	this.dragonWrap = new lib.dragonWrap();
	this.dragonWrap.name = "dragonWrap";
	this.dragonWrap.parent = this;
	this.dragonWrap.setTransform(421,523.5,1,1,0,0,0,298,403.5);

	this.timeline.addTween(cjs.Tween.get(this.dragonWrap).wait(1));

	// bg2
	this.BG2 = new lib.bg2_1();
	this.BG2.name = "BG2";
	this.BG2.parent = this;
	this.BG2.setTransform(298,403.5,1,1,0,0,0,298,403.5);

	this.timeline.addTween(cjs.Tween.get(this.BG2).wait(1));

	// bg1
	this.BG1 = new lib.BG001_1();
	this.BG1.name = "BG1";
	this.BG1.parent = this;
	this.BG1.setTransform(298,403.5,1,1,0,0,0,298,403.5);

	this.timeline.addTween(cjs.Tween.get(this.BG1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.4,403.5,9473.9,816.5);
// library properties:
lib.properties = {
	id: 'EC8E2C9BC49BE74590BBF29685F20A65',
	width: 596,
	height: 807,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:require("./images/ani_test_atlas_P_.png?1625508652539"), id:"ani_test_atlas_P_"},
		{src:require("./images/ani_test_atlas_P_2.png?1625508652539"), id:"ani_test_atlas_P_2"},
		{src:require("./images/ani_test_atlas_P_3.png?1625508652540"), id:"ani_test_atlas_P_3"},
		{src:require("./images/ani_test_atlas_P_4.png?1625508652540"), id:"ani_test_atlas_P_4"},
		{src:require("./images/ani_test_atlas_P_5.png?1625508652541"), id:"ani_test_atlas_P_5"},
		{src:require("./images/ani_test_atlas_P_6.png?1625508652541"), id:"ani_test_atlas_P_6"},
		{src:require("./images/ani_test_atlas_P_7.png?1625508652542"), id:"ani_test_atlas_P_7"},
		{src:require("./images/ani_test_atlas_P_8.png?1625508652542"), id:"ani_test_atlas_P_8"},
		{src:require("./images/ani_test_atlas_P_9.png?1625508652543"), id:"ani_test_atlas_P_9"},
		{src:require("./images/ani_test_atlas_P_10.png?1625508652546"), id:"ani_test_atlas_P_10"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['EC8E2C9BC49BE74590BBF29685F20A65'] = {
	getStage: function() { return exportRoot.getStage(); },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}

window.AdobeAn = an;

})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var AdobeAn;